import * as tslib_1 from "tslib";
import { CONTRACTS_LIST, ERROR_102, ERROR_103, ERROR_104, ERROR_105, ERROR_107, ERROR_108, ERROR_111, ERROR_112, ERROR_113, ERROR_121, ERROR_122, ERROR_123, ERROR_124, ERROR_125, ERROR_126, ERROR_127, ERROR_128, ERROR_129, ERROR_130, ERROR_400, ERROR_131, ERROR_132, ERROR_133, ERROR_135, ERROR_137, ERROR_140, ERROR_141, ERROR_401, ERROR_402, ERROR_403, ERROR_404, ERROR_500, ERROR_501, ERROR_502, ERROR_512, ERROR_514, ERROR_602, ERROR_BRANCH, ERROR_DBS, ERROR_NONE, ERROR_TECH, ERROR_LIB, ERROR_142, ERROR_134, ERROR_138, ERROR_136, ERROR_139, ERROR_143, ERROR_999, ERROR_0104, } from '../../constants/abre-cuentas.constants';
import { BUSINESS_CONST } from '../../constants/business.constants';
import { OpEnum } from '../../enums/op.enum';
import { AbreCuentasModel, CityModel, } from '../../models/abre-cuentas.model';
import { ContactModel } from '../../models/contact.model';
import { ErrorModel } from '../../models/error.model';
import { CopyService } from '../copies/copy.service';
import { HelpersService } from '../helpers/helpers-onboarding.service';
import { LoadingService } from '../loading/loading.service';
import { ERROR_600, ERROR_601, ERROR_603, } from './../../constants/abre-cuentas.constants';
import { CHANNEL } from 'src/app/shared/constants/channel.constants';
import { ParametersService } from '../parameters/parameters.service';
var AbreCuentasService = /** @class */ (function () {
    function AbreCuentasService(copiesService, loadingService, helperService, parametersService) {
        this.copiesService = copiesService;
        this.loadingService = loadingService;
        this.helperService = helperService;
        this.parametersService = parametersService;
        /**
         * Contiene los productos seleccionados en la pantalla de vinculación
         */
        this.productsSelectVicul = [];
        this.parametrizedHeaders = undefined;
        this.userJemelii = false;
        /**
         *
         *
         * *
         *
         *
         */
        this.intentos = 0;
        this.validationOtp = 0;
        /**
         * Inicialización de devicePermission en vacio
         *
         * *Setting up devicePermissiones as null*
         *
         * @access              private
         * @type                {string}
         */
        this.devicePermissions = '';
        /**
         * Inicialización de documento subido
         * *Setting up request*
         *
         * @access              private
         * @type                {boolean}
         */
        this.documentsUploaded = false;
        /**
         * Instancia de errorInfo como ErroeModel
         *
         * *Instance of errorInfo as ErrorModel*
         *
         * @access              private
         * @type                {string}
         */
        this.errorInfo = new ErrorModel();
        this.pep = 'No';
        /**
         * Summary      Constructor of the component.
         * @param       {LoadingService}            loadingService              Injectable loadingService service.
         * @param       {HelperService}             helperService               Injectable helperService service.
         */
        /**
         * productos seleecionados flujo multi-producto
         */
        this.productSelect = [];
        /**
         * productos consultados flujo multi-producto
         */
        this.maxproducts = [];
        /**
         * Variable para ver/ocultar opciones de multi-producto
         */
        this.viewOptionMultiProduct = false;
        /**
         * Variable para ver/ocultar opciones de dualidad
         */
        this.isCardDuality = false;
        /**
         * Variables para saber si en los productos seleccionados tiene libranzas
         */
        this.haveLoan = false;
        /**
         * Variable para saber si el cliente esta en normalizacion
         */
        this.isNormalizacion = false;
        this.didBackAddLoan = false;
        /**
         * datos de los creditos a retanquear
         */
        this.creditIndex = 0;
        this.editCredit = false;
        this.creditList = [];
        this.deleteCredit = false;
        /**
         * Variable para saber si se cambio priorizacion.
         */
        this.priorization = false;
        /**
         * Variable para saber si se hizo marca en bitacora.
         */
        this.sellerboolean = false;
        /**
         * Variable para almacenar si existe error 01-04 de pco
         */
        this.isErrorPco = false;
        if (!this.abreCuentasModel) {
            this.abreCuentasModel = new AbreCuentasModel();
        }
    }
    /**
     * Retorna una función con determinada cantidad de tiempo
     * Returns tiem interval function
     *
     * @param {number} delay till this time succed
     * @returns un interval de tiempo
     */
    AbreCuentasService.prototype.sleep = function (delay) {
        return new Promise(function (r) {
            setTimeout(r, delay);
        });
    };
    /**
     * Retorna la fecha con el formato yy-mm-dd T hh:mm:ss
     *
     * *Returns formatted Date yy-mm-dd T hh:mm:ss*
     *
     * @param {Date} Date
     * @returns Fecha en formato yy-mm-dd T hh:mm:ss
     */
    AbreCuentasService.prototype.formatDate = function (date) {
        var dayOfMonth = date.getDate();
        var month = date.getMonth() + 1;
        var year = date.getFullYear();
        var hour = date.getHours();
        var minutes = date.getMinutes();
        var seconds = date.getSeconds();
        var monthString = month < 10 ? '0' + month : month;
        var dayString = dayOfMonth < 10 ? '0' + dayOfMonth : dayOfMonth;
        return year + "-" + monthString + "-" + dayString + "T" + hour + ":" + minutes + ":" + seconds;
    };
    /**
     * Retorna la fecha con el formato yy-mm-dd T hh:mm:ss
     *
     * *Returns formatted Date yy-mm-dd T hh:mm:ss*
     *
     * @param {Date} Date
     * @returns Fecha en formato yy-mm-dd T hh:mm:ss
     */
    AbreCuentasService.prototype.formatDateSpanish = function (withHour, time) {
        var monthComplete = time.toLocaleString('es-Co', { month: 'long' });
        var month = monthComplete[0].toUpperCase() + monthComplete.slice(1, 3);
        var date = time.getDate() + " de " + monthComplete + " " + time.getFullYear();
        if (withHour) {
            var hour = time.toLocaleString('en-US', {
                hour: 'numeric',
                minute: 'numeric',
                hour12: true,
            });
            date += " a las " + hour;
        }
        return date;
    };
    /**
     * Muestra el icono generico de cargando
     *
     * *Shows generic loading icon*
     */
    AbreCuentasService.prototype.showGenericLoading = function () {
        this.loadingService.show();
    };
    /**
     * Oculta el icono generico de cargando
     *
     * *Hides generic loading icon*
     */
    AbreCuentasService.prototype.hideGenericLoading = function () {
        this.loadingService.hide();
    };
    /**
     * Obtener modelo de AbreCuentas
     *
     * *Gets AbreCuentasModel*
     *
     * @returns {AbreCuentasModel} abreCuentasModel
     */
    AbreCuentasService.prototype.getAbreCuentasModel = function () {
        return this.abreCuentasModel;
    };
    /**
     * Inicializar product destination type
     *
     * *sets productDestinationType*
     *
     * @param {string} type
     */
    AbreCuentasService.prototype.setProductDestinationType = function (type) {
        this.productDestinationType = type;
    };
    AbreCuentasService.prototype.getProductDestinationType = function () {
        return this.productDestinationType;
    };
    /**
     * Inicializar el modelo de AbreCuentas
     *
     * *Sets AbreCuentasModel*
     *
     * @param {AbreCuentasModel} abrecuentasModel
     */
    AbreCuentasService.prototype.setAbreCuentasModel = function (abreCuentasModel) {
        this.abreCuentasModel = abreCuentasModel;
    };
    /**
     * Inicializar transaction_id
     *
     * *Gets transaction_id*
     *
     * @returns {string} this.abreCuentasModel.protransaction_idspectId
     */
    AbreCuentasService.prototype.setTransactionId = function (transactionId) {
        return (this.abreCuentasModel.transaction_id = transactionId);
    };
    /**
     * Obtener transaction_id
     *
     * *Gets transaction_id*
     *
     * @returns {string} this.abreCuentasModel.transaction_id
     */
    AbreCuentasService.prototype.getTransactionId = function () {
        return this.abreCuentasModel.transaction_id;
    };
    /**
     * Inicializar transaction_status
     *
     * *Gets transaction_status*
     *
     * @returns {string} this.abreCuentasModel.transaction_status
     */
    AbreCuentasService.prototype.setTransactionStatus = function (transactionStatus) {
        return (this.abreCuentasModel.transaction_status = transactionStatus);
    };
    /**
     * Obtener transaction_status
     *
     * *Gets transaction_status*
     *
     * @returns {string} this.abreCuentasModel.transaction_status
     */
    AbreCuentasService.prototype.getTransactionStatus = function () {
        return this.abreCuentasModel.transaction_status;
    };
    /**
     * Obtener ProspectId
     *
     * *Gets ProspectId*
     *
     * @returns {string} this.abreCuentasModel.prospectId
     */
    AbreCuentasService.prototype.getProspectId = function () {
        return this.abreCuentasModel.prospectId;
    };
    /**
     * Obtener Id de solicitud
     *
     * *Gets Solicitation Id*
     *
     * @returns {string} this.abreCuentasModel.solicitationId
     */
    AbreCuentasService.prototype.getSolicitationId = function () {
        return this.abreCuentasModel.solicitationId;
    };
    /**
     * Obtener Id de solicitud
     *
     * *Gets Solicitation Info*
     *
     * @returns {string} this.abreCuentasModel.solicitationInfo
     */
    AbreCuentasService.prototype.getSolicitationInfo = function () {
        return this.abreCuentasModel.solicitationInfo;
    };
    /**
     * Obtiene los parametros de subida
     *
     * *Gets uploadedParams*
     *
     * @returns {any[]} this.abreCuentasModel.uploadParams
     */
    AbreCuentasService.prototype.getUploadParams = function () {
        return this.abreCuentasModel.uploadParams;
    };
    /**
     * Obtiene las listas de URL
     *
     * *Gets UrlLists*
     *
     * @returns {any[]} this.abreCuentasModel.urlList
     */
    AbreCuentasService.prototype.getUrlList = function () {
        return this.abreCuentasModel.urlList;
    };
    AbreCuentasService.prototype.setChannelNotificationData = function (id) {
        this.abreCuentasModel.channelNot_SolicitationId = id;
    };
    AbreCuentasService.prototype.getChannelNotificationData = function () {
        return this.abreCuentasModel.channelNot_SolicitationId;
    };
    /**
     * Obtiene el tipo de configuracion Bytte
     *
     * *Gets BytteConfig type*
     *
     * @returns {BytteConfigType} this.abreCuentasModel.bytteConfig
     */
    AbreCuentasService.prototype.getBytteConfig = function () {
        return this.abreCuentasModel.bytteConfig;
    };
    /**
     * Inicializa la configuracion Bytte
     *
     * *Sets up BytteConfig*
     *
     * @param {BytteConfigType} config
     */
    AbreCuentasService.prototype.setBytteConfig = function (config) {
        this.abreCuentasModel.bytteConfig = config;
    };
    /**
     * Obtiene la configuración DsbMobile
     *
     * *Gets DsbMobile Configuration*
     *
     * @returns {DSBMobileConfig} this.abreCuentasModel.dsbMobileCofig
     */
    AbreCuentasService.prototype.getDsbMobileConfig = function () {
        return this.abreCuentasModel.dsbMobileCofig;
    };
    /**
     * Inicializa la configuración DsbMobile
     *
     * *Sets up DsbMobile*
     *
     * @param {any} config
     */
    AbreCuentasService.prototype.setDsbMobileConfig = function (config) {
        this.abreCuentasModel.dsbMobileCofig = config;
    };
    /**
     * Obtiene la configuarción BioCatch
     *
     * *Gets BioCatch configuration*
     *
     * @returns {BioCatchConfigModel} this.abreCuentasModel.biocatchConfig
     */
    AbreCuentasService.prototype.getBioCatchConfig = function () {
        return this.abreCuentasModel.biocatchConfig;
    };
    /**
     * Inicializa la configuracion BioCatch
     *
     * *Sets up BioCatch*
     *
     * @param {any} config
     */
    AbreCuentasService.prototype.setBioCatchConfig = function (config) {
        this.abreCuentasModel.biocatchConfig = config;
    };
    /**
     * Obtiene Dsb Security Check Expection parámetro
     *
     * *Gets Dsb Security Check Expection parameter*
     *
     * @returns {string} this.abreCuentasModel.dsbSecurityCheckException
     */
    AbreCuentasService.prototype.getDsbSecurityCheckException = function () {
        return this.abreCuentasModel.dsbSecurityCheckException;
    };
    /**
     * Inicializa Dsb Security Check Expection parámetro
     *
     * *Sets up Dsb Security Check Expection parameter*
     *
     * @param {string} code
     */
    AbreCuentasService.prototype.setDsbSecurityCheckException = function (code) {
        this.abreCuentasModel.dsbSecurityCheckException = code;
    };
    /**
     * Obtiene el parámetro FinancialInfo
     *
     * *Gets FinancialInfo parameter*
     *
     * @returns {FinancialModel} this.abreCuentasModel.financialModel
     */
    AbreCuentasService.prototype.getFinancialInfo = function () {
        return this.abreCuentasModel.financialModel;
    };
    /**
     * Inicializa el parámetro FinancialInfo
     *
     * *Set FinancialInfo parameter*
     *
     * @param {FinancialInfo} financialInfo
     */
    AbreCuentasService.prototype.setFinancialInfo = function (financialInfo) {
        this.abreCuentasModel.financialModel = financialInfo;
    };
    /**
     * Obtiene el parámetro FinancialSecondHeadlineInfo
     *
     * *Gets FinancialSecondHeadlineInfo parameter*
     *
     * @returns {FinancialSecondHeadlineModel} this.abreCuentasModel.financialSecondHeadlineModel
     */
    AbreCuentasService.prototype.getFinancialSecondHeadlineInfo = function () {
        return this.abreCuentasModel.financialSecondHeadlineModel;
    };
    /**
     * Inicializa el parámetro FinancialInfo
     *
     * *Set FinancialInfo parameter*
     *
     * @param {FinancialInfo} financialInfo
     */
    AbreCuentasService.prototype.setFinancialSecondHeadlineInfo = function (financialSecondHeadlineInfo) {
        this.abreCuentasModel.financialSecondHeadlineModel =
            financialSecondHeadlineInfo;
    };
    /**
     * Obtiene el parámetro OtherFinancialInfo
     *
     * *Gets OtherFinancialInfo parameter*
     *
     * @returns {OtherFinancialModel} this.abreCuentasModel.otherFinancialModel
     */
    AbreCuentasService.prototype.getOtherFinancialInfo = function () {
        return this.abreCuentasModel.otherFinancialModel;
    };
    /**
     * Inicializa el parámetro FinancialInfo
     *
     * *Set FinancialInfo parameter*
     *
     * @param {FinancialInfo} financialInfo
     */
    AbreCuentasService.prototype.setOtherFinancialInfo = function (otherFinancialInfo) {
        this.abreCuentasModel.otherFinancialModel = otherFinancialInfo;
    };
    /**
     * Obtiene el parámetro OtherFinancialInfo
     *
     * *Gets OtherFinancialInfo parameter*
     *
     * @returns {OtherFinancialModel} this.abreCuentasModel.otherFinancialSecondHeadlineModel
     */
    AbreCuentasService.prototype.getOtherFinancialSecondHeadlineInfo = function () {
        return this.abreCuentasModel.otherFinancialSecondHeadlineModel;
    };
    /**
     * Inicializa el parámetro FinancialInfo
     *
     * *Set FinancialInfo parameter*
     *
     * @param {FinancialInfo} financialInfo
     */
    AbreCuentasService.prototype.setOtherFinancialSecondHeadlineInfo = function (otherFinancialSecondHeadlineModel) {
        this.abreCuentasModel.otherFinancialSecondHeadlineModel =
            otherFinancialSecondHeadlineModel;
    };
    /**
     * Obtiene el parámetro ContactInfo
     *
     * *Gets ContactInfo parameter*
     *
     * @returns {ContactModel} this.abreCuentasModel.ContactModel
     */
    AbreCuentasService.prototype.getContactInfo = function () {
        return this.abreCuentasModel.ContactModel;
    };
    /**
     * Inicializa el parámetro ContactInfo
     *
     * *Sets ContactInfo parameter*
     *
     * @param {ContactModel} contactInfo
     */
    AbreCuentasService.prototype.setContactInfo = function (contactInfo) {
        this.abreCuentasModel.ContactModel = contactInfo;
    };
    AbreCuentasService.prototype.getBasicInfo = function () {
        return this.abreCuentasModel.basicModel;
    };
    AbreCuentasService.prototype.setBasictInfo = function (basicInfo) {
        this.abreCuentasModel.basicModel = basicInfo;
    };
    /**
     * Inicializa el parámetro foreignProductsInfo
     * *Sets foreignProductsInfo parameter*
     *
     * @param {ForeignProductsModel} productInfo
     */
    AbreCuentasService.prototype.setProductInfo = function (productInfo) {
        this.abreCuentasModel.foreignProductsInfo = productInfo;
    };
    /**
     * Obtiene el parámetro foreignProductsInfo
     * *Gets foreignProductsInfo parameter*
     *
     * @returns {ForeignProductsModel} this.abreCuentasModel.foreignProductsInfo
     */
    AbreCuentasService.prototype.getProductInfo = function () {
        return this.abreCuentasModel.foreignProductsInfo;
    };
    /**
     * Inicializa el parámetro ethnicGroupInfo
     * *Sets ethnicGroupInfo parameter*
     *
     * @param {EthnicGroupModel} ethnicGroupInfo
     */
    AbreCuentasService.prototype.setEthnicGroupInfo = function (ethnicGroupInfo) {
        this.abreCuentasModel.ethnicGroupInfo = ethnicGroupInfo;
    };
    /**
     * Obtiene el parámetro maritalStatusModel
     * *Gets maritalStatusModel parameter*
     *
     * @returns {EthnicGroupModel} *this.abreCuentasModel.maritalStatusModel*
     */
    AbreCuentasService.prototype.getEthnicGroupInfo = function () {
        return this.abreCuentasModel.ethnicGroupInfo;
    };
    /**
     * Inicializa el parámetro birthplaceInfo
     * *Sets birthplaceInfo parameter*
     *
     * @param {CityModel} birthplaceInfo
     */
    AbreCuentasService.prototype.setBirthplaceInfo = function (birthplaceInfo) {
        this.abreCuentasModel.birthplaceInfo = birthplaceInfo;
    };
    /**
     * Inicializa el parámetro birthCountry
     * *Sets birthCountry parameter*
     *
     * @param {CountryModel} birthCountry
     */
    AbreCuentasService.prototype.setBirthCountry = function (birthCountry) {
        this.abreCuentasModel.birthCountry = birthCountry;
    };
    /**
     * Inicializa el parámetro maritalStatusModel
     * *Sets maritalStatusModel parameter*
     *
     * @param {MaritalStatusModel} maritalStatusModel
     */
    AbreCuentasService.prototype.setMaritalStatusInfo = function (maritalStatusModel) {
        this.abreCuentasModel.maritalStatusModel = maritalStatusModel;
    };
    /**
     * Inicializa el parámetro maritalStatusModel Segundo Titular
     * *Sets maritalStatusModel parameter*
     *
     * @param {MaritalStatusSecondHeadlineModel} MaritalStatusSecondHeadlineModel
     */
    AbreCuentasService.prototype.setMaritalStatusSecondHeadline = function (maritalStatusSecondHeadlineModel) {
        this.abreCuentasModel.maritalStatusSecondHeadlineModel =
            maritalStatusSecondHeadlineModel;
    };
    /**
     * Obtiene el parámetro maritalStatusModel
     * *Gets maritalStatusModel parameter*
     *
     * @returns {.maritalStatusSecondHeadlineModel} *this.abreCuentasModel.maritalStatusModel*
     */
    AbreCuentasService.prototype.getMaritalStatusSecondHeadLine = function () {
        return this.abreCuentasModel.maritalStatusSecondHeadlineModel;
    };
    /**
     * Inicializa el parámetro SecondHeadlineModel
     * *Sets SecondHeadlineModel parameter*
     *
     * @param {SecondHeadlineModel} SecondHeadlineModel
     */
    AbreCuentasService.prototype.setSecondHeadline = function (secondHeadlineModel) {
        this.abreCuentasModel.secondHeadlineModel = secondHeadlineModel;
    };
    /**
     * Obtiene el parámetro SecondHeadlineModel
     * *Gets SecondHeadlineModel parameter*
     *
     * @returns {SecondHeadlineModel} *this.abreCuentasModel.SecondHeadline*
     */
    AbreCuentasService.prototype.getSecondHeadline = function () {
        return this.abreCuentasModel.secondHeadlineModel;
    };
    /**
     * Inicializa el parámetro BasicInfoSecondHeadlineModel
     * *Sets BasicInfoSecondHeadlineModel parameter*
     *
     * @param {BasicInfoSecondHeadlineModel} BasicInfoSecondHeadlineModel
     */
    AbreCuentasService.prototype.setBasicInfoSecondHeadline = function (basicInfosecondHeadlineModel) {
        this.abreCuentasModel.basicInfoSecondHeadlineModel =
            basicInfosecondHeadlineModel;
    };
    /**
     * Obtiene el parámetro SecondHeadlineModel
     * *Gets SecondHeadlineModel parameter*
     *
     * @returns {SecondHeadlineModel} *this.abreCuentasModel.SecondHeadline*
     */
    AbreCuentasService.prototype.getBasicInfoSecondHeadline = function () {
        return this.abreCuentasModel.basicInfoSecondHeadlineModel;
    };
    /**
     * Inicializa el parámetro ContactSecondHeadlineModel
     * *Sets ContactSecondHeadlineModel parameter*
     *
     * @param {ContactSecondHeadlineModel} ContactSecondHeadlineModel
     */
    AbreCuentasService.prototype.setContactInfoSecondHeadline = function (contactSecondHeadlineModel) {
        this.abreCuentasModel.contactSecondHeadlineModel =
            contactSecondHeadlineModel;
    };
    /**
     * Obtiene el parámetro ContactSecondHeadlineModel
     * *Gets ContactSecondHeadlineModel parameter*
     *
     * @returns {contactContactSecondHeadlineModel} *this.abreCuentasModel.contactContactSecondHeadlineModel*
     */
    AbreCuentasService.prototype.getContactInfoSecondHeadline = function () {
        return this.abreCuentasModel.contactSecondHeadlineModel;
    };
    /**
     * Obtiene el parámetro birthplaceInfo
     * *Gets birthplaceInfo parameter*
     *
     * @returns {CityModel} *this.abreCuentasModel.birthplaceInfo*
     */
    AbreCuentasService.prototype.getBirthplaceInfo = function () {
        return this.abreCuentasModel.birthplaceInfo;
    };
    /**
     * Obtiene el parámetro birthCountry
     * *Gets birthCountry parameter*
     *
     * @returns {CountryModel} *this.abreCuentasModel.birthCountry*
     */
    AbreCuentasService.prototype.getBirthCountry = function () {
        return this.abreCuentasModel.birthCountry;
    };
    /**
     * Obtiene el parámetro maritalStatusModel del segundo titular
     * *Gets maritalStatusModel parameter*
     *
     * @returns {MaritalStatusModel} *this.abreCuentasModel.maritalStatusModel*
     */
    AbreCuentasService.prototype.getMaritalStatusInfo = function () {
        return this.abreCuentasModel.maritalStatusModel;
    };
    /**
     * Inicializa el parámetro AccountSelectionModel
     * *Sets AccountSelectionModel parameter*
     *
     * @param {AccountSelectionModel} accountSelectionModel
     */
    AbreCuentasService.prototype.setAccountSelectionInfo = function (accountSelectionModel) {
        this.abreCuentasModel.accountSelectionModel = accountSelectionModel;
    };
    /**
     * Obtiene el parámetro accountSelectionModel
     * *Gets accountSelectionModel parameter*
     *
     * @returns {AccountSelectionModel} *this.abreCuentasModel.accountSelectionModel*
     */
    AbreCuentasService.prototype.getAccountSelectionInfo = function () {
        return this.abreCuentasModel.accountSelectionModel;
    };
    /**
     * Inicializa el parámetro prospectId
     *
     * *Sets prospectId parameter*
     *
     * @param {string} id
     */
    AbreCuentasService.prototype.setProspectId = function (id) {
        this.abreCuentasModel.prospectId = id;
    };
    /**
     * Inicializa el parámetro solicitationId
     *
     * *Sets solicitationId parameter*
     *
     * @param {string} id
     */
    AbreCuentasService.prototype.setSolicitationId = function (id) {
        this.abreCuentasModel.solicitationId = id;
    };
    /**
     * Inicializa el parámetro solicitationInfo
     *
     * *Sets solicitationInfo parameter*
     *
     * @param {any[]} info
     */
    AbreCuentasService.prototype.setSolicitationInfo = function (info) {
        this.abreCuentasModel.solicitationInfo = info;
    };
    /**
     * Inicializa el parámetro uploadParams
     *
     * *Sets uploadParams parameter*
     *
     * @param {any[]} uploadParams
     */
    AbreCuentasService.prototype.setUploadParams = function (uploadParams) {
        this.abreCuentasModel.uploadParams = uploadParams;
    };
    /**
     * Inicializa el parámetro urlList
     *
     * *Sets urlList parameter*
     *
     * @param {any[]} urlList
     */
    AbreCuentasService.prototype.setUrlList = function (urlList) {
        this.abreCuentasModel.urlList = urlList;
    };
    /**
     * Obtiene el parámetro domicilioModel
     *
     * *Gets domicilioModel parameter*
     *
     * @returns {DomicilioModel} this.abreCuentasModel.domicilioModel
     */
    AbreCuentasService.prototype.getDomicilioModel = function () {
        return this.abreCuentasModel.domicilioModel;
    };
    /**
     * Obtiene el parámetro listsModel
     *
     * *Gets listsModel parameter*
     *
     * @returns {ListsModel} *this.abreCuentasModel.listsModel*
     */
    AbreCuentasService.prototype.getListsModel = function () {
        return this.abreCuentasModel.listsModel;
    };
    /**
     * Obtiene el parámetro fiModel
     *
     * *Get fiModel parameter*
     *
     * @returns {FiModel} *this.abreCuentasModel.fiModel*
     */
    AbreCuentasService.prototype.getFiModel = function () {
        return this.abreCuentasModel.fiModel;
    };
    /**
     * Inicializa el parámetro fiModel
     *
     * *Sets fiModel parameter*
     *
     * @param {FiModel} fiModel
     */
    AbreCuentasService.prototype.setFiModel = function (fiModel) {
        this.abreCuentasModel.fiModel = fiModel;
    };
    /**
     * Obtiene el parámetro pldModel
     *
     * *Gets pldModel parameter*
     *
     * @returns {PldModel} this.abreCuentasModel.pldModel
     */
    AbreCuentasService.prototype.getPldModel = function () {
        return this.abreCuentasModel.pldModel;
    };
    /**
     * Obtiene el parámetro photosModel
     *
     * *Gets photosModel parameter*
     *
     * @returns {PhotosModel} this.abreCuentasModel.photosModel
     */
    AbreCuentasService.prototype.getPhotosModel = function () {
        return this.abreCuentasModel.photosModel;
    };
    /**
     * Inicializa el parámetro photosModel
     *
     * *Sets photosModel parameter*
     *
     * @param {PhotosModel} photosModel
     */
    AbreCuentasService.prototype.setPhotosModel = function (photosModel) {
        this.abreCuentasModel.photosModel = photosModel;
    };
    /**
     * Obtiene el parámetro photosModel
     *
     * *Gets photosModel parameter*
     *
     * @param {string} property
     * @returns {PhotosModel} this.abreCuentasModel.photosModel[property]
     */
    AbreCuentasService.prototype.getPhotosProperty = function (property) {
        return this.abreCuentasModel.photosModel[property];
    };
    /**
     * Inicializa el parámetro photosModel[property] igual value
     *
     * *Sets photosModel[property] parameter equal to value*
     *
     * @param {string} property
     * @param {any} value
     */
    AbreCuentasService.prototype.setPhotosProperty = function (property, value) {
        this.abreCuentasModel.photosModel[property] = value;
    };
    /**
     * Obtiene el parámetro domicilioModel
     *
     * *Gets domicilioModel parameter*
     *
     * @param {string} property
     * @returns {DomicilioModel} this.abreCuentasModel.domicilioModel[property]
     */
    AbreCuentasService.prototype.getDomicilioProperty = function (property) {
        return this.abreCuentasModel.domicilioModel[property];
    };
    /**
     * Inicializa el parámetro domicilioModel[property] igual value
     *
     * *Sets domicilioModel[property] parameter equal to value*
     *
     * @param {string} property
     * @param {any} value
     */
    AbreCuentasService.prototype.setDomicilioProperty = function (property, value) {
        this.abreCuentasModel.domicilioModel[property] = value;
    };
    /**
     * Obtiene el parámetro fiModel
     *
     * *Gets fiModel parameter*
     *
     * @param {string} property
     * @returns {FiModel} this.abreCuentasModel.fiModel[property]
     */
    AbreCuentasService.prototype.getFiProperty = function (property) {
        return this.abreCuentasModel.fiModel[property];
    };
    /**
     * Inicializa el parámetro fiModel[property] igual value
     *
     * *Sets fiModel[property] parameter equal to value*
     *
     * @param {string} property
     * @param {any} value
     */
    AbreCuentasService.prototype.setFiProperty = function (property, value) {
        this.abreCuentasModel.fiModel[property] = value;
    };
    /**
     * Inicializa el parámetro fiModel[property] igual value secondheadline
     *
     * *Sets fiModel[property] parameter equal to value secondheadline*
     *
     * @param {string} property
     * @param {any} value
     */
    AbreCuentasService.prototype.setFiPropertySecondHeadline = function (property, value) {
        this.abreCuentasModel.fiSecondHeadlineModel[property] = value;
    };
    AbreCuentasService.prototype.getFiPropertySecondHeadline = function (property) {
        return this.abreCuentasModel.fiSecondHeadlineModel[property];
    };
    /**
     * Obtiene el parámetro errorModel
     *
     * *Gets errorModel parameter*
     *
     * @returns {ErrorModel} this.abreCuentasModel.errorModel
     */
    AbreCuentasService.prototype.getErrorProperty = function () {
        return this.abreCuentasModel.errorModel;
    };
    /**
     * Inicializa el parámetro errorModel igual model
     *
     * *Sets errorModel parameter equal to model*
     *
     * @param {ErrorModel} model
     */
    AbreCuentasService.prototype.setErrorProperty = function (model) {
        this.abreCuentasModel.errorModel = model;
    };
    /**
     * Obtiene el parámetro errorModel
     *
     * *Gets errorModel parameter*
     *
     * @returns {ErrorDateModel} this.abreCuentasModel.errorDateModel
     */
    AbreCuentasService.prototype.getErrorDateProperty = function () {
        return this.abreCuentasModel.errorDateModel;
    };
    /**
     * Inicializa el parámetro errorDateModel igual model
     *
     * *Sets errorDateModel parameter equal to model*
     *
     * @param {any} model
     */
    AbreCuentasService.prototype.setErrorDateProperty = function (model) {
        this.abreCuentasModel.errorDateModel = model;
    };
    /**
     * Inicializa el parámetro documentModel igual model
     *
     * *Sets documentModel parameter equal to model*
     *
     * @param {DocumentModel} model
     */
    AbreCuentasService.prototype.setDocumentInfo = function (model) {
        this.abreCuentasModel.documentModel = model;
    };
    /**
     * Obtiene el parámetro documentModel
     *
     * *Gets documentModel parameter*
     *
     * @returns {DocumentModel} this.abreCuentasModel.documentModel
     */
    AbreCuentasService.prototype.getDocumentInfo = function () {
        return this.abreCuentasModel.documentModel;
    };
    /**
     * Inicializa el parámetro documentModel igual model
     *
     * *Sets documentModel parameter equal to model*
     *
     * @param {DocumentModel} model
     */
    AbreCuentasService.prototype.setPostlogin = function (isPostlogin) {
        this.abreCuentasModel.isPostlogin = isPostlogin;
    };
    /**
     * Obtiene el parámetro documentModel
     *
     * *Gets documentModel parameter*
     *
     * @returns {DocumentModel} this.abreCuentasModel.documentModel
     */
    AbreCuentasService.prototype.getPostlogin = function () {
        return this.abreCuentasModel.isPostlogin;
    };
    /**
     * Obtiene el parámetro pldModel[property]
     *
     * *Gets pldModel[property] parameter*
     *
     * @param {string} property
     * @returns {PldModel} this.abreCuentasModel.pldModel[property]
     */
    AbreCuentasService.prototype.getPldProperty = function (property) {
        return this.abreCuentasModel.pldModel[property];
    };
    /**
     * Inicializa el parámetro pldModel[property] igual value
     *
     * *Sets pldModel[property] parameter equal to value*
     *
     * @param {string} property
     * @param {any} value
     */
    AbreCuentasService.prototype.setPldProperty = function (property, value) {
        this.abreCuentasModel.pldModel[property] = value;
    };
    /**
     * @param type (event,page)
     * @param key (key)
     * @param data (data sett)
     */
    AbreCuentasService.prototype.setDataTagg = function (type, key, page, pageEvent, data) {
        if (type == 'page') {
            this.dataTagg.PAGEVIEW["pv" + page + key].value = data;
        }
        else if (type == 'event') {
            this.dataTagg.EVENT["pv" + page + "E" + pageEvent + "setData"]["pv" + page + "E" + pageEvent + key].value = data;
        }
    };
    AbreCuentasService.prototype.setTaggeo = function (data) {
        this.dataTagg = data;
    };
    AbreCuentasService.prototype.getDataTagg = function () {
        return this.dataTagg;
    };
    AbreCuentasService.prototype.getBusinessConfig = function (key) {
        return this.abreCuentasModel.businessConfigMap[key.toString()];
    };
    AbreCuentasService.prototype.setBusinessConfig = function (key, config) {
        return (this.abreCuentasModel.businessConfigMap[key] = config);
    };
    AbreCuentasService.prototype.setIntentoOtp = function (intentos) {
        this.intentos = intentos;
    };
    AbreCuentasService.prototype.getIntentoOtp = function () {
        return this.intentos;
    };
    AbreCuentasService.prototype.setValidationOtp = function (intentos) {
        this.validationOtp = intentos;
    };
    AbreCuentasService.prototype.getValidationOtp = function () {
        return this.validationOtp;
    };
    /**
     * Obtiene el parámetro detailAccountModel
     *
     * *Gets detailAccountModel parameter*
     *
     * @returns {DetailAccountModel} this.abreCuentasModel.detailAccountModel
     */
    AbreCuentasService.prototype.getDetailAccountCreation = function () {
        return this.abreCuentasModel.detailAccountModel;
    };
    /**
     * Inicializa el parámetro detailAccountModel igual detailAccountInfo
     *
     * *Sets detailAccountModel parameter equal to detailAccountInfo*
     *
     * @param {DetailAccountModel} detailAccountInfo
     */
    AbreCuentasService.prototype.setDetailAccountCreation = function (detailAccountInfo) {
        this.abreCuentasModel.detailAccountModel = detailAccountInfo;
    };
    /**
     * Obtiene el parámetro DetailRevolvingCreditModel
     *
     * *Gets DetailRevolvingCreditModel parameter*
     *
     * @returns {DetailRevolvingCreditModel} this.abreCuentasModel.detailRevolvingCreditModel
     */
    AbreCuentasService.prototype.getDetailRevolvingCreditCreation = function () {
        return this.abreCuentasModel.detailRevolvingCreditModel;
    };
    /**
     * Inicializa el parámetro detailRevolvingCreditModel igual detailRevolvingCreditInfo
     *
     * *Sets detailRevolvingCreditModel parameter equal to detailRevolvingCreditInfo*
     *
     * @param {DetailRevolvingCreditModel} detailAccountInfo
     */
    AbreCuentasService.prototype.setDetailRevolvingCreditCreation = function (detailRevolvingCreditInfo) {
        this.abreCuentasModel.detailRevolvingCreditModel =
            detailRevolvingCreditInfo;
    };
    /**
     * Obtiene el parámetro employedContractModel
     *
     * *Gets employedContractModel parameter*
     *
     * @returns {EmployedContractModel} this.abreCuentasModel.employedContractModel
     */
    AbreCuentasService.prototype.getEmployedContractModel = function () {
        return this.abreCuentasModel.employedContractModel;
    };
    /**
     * Inicializa el parámetro employedContractModel igual employedContractModel
     *
     * *Sets employedContractModel parameter equal to employedContractModel*
     *
     * @param {EmployedContractModel} employedContractModel
     */
    AbreCuentasService.prototype.setEmployedContractModel = function (employedContractModel) {
        this.abreCuentasModel.employedContractModel = employedContractModel;
    };
    /**
     * Obtiene el parámetro employedContractSecondHeadlineModel
     *
     * *Gets employedContractSecondHeadlineModel parameter*
     *
     * @returns {EmployedContractSecondHeadlineModel} this.abreCuentasModel.employedContractSecondHeadlineModel
     */
    AbreCuentasService.prototype.getEmployedContractSecondHeadlineModel = function () {
        return this.abreCuentasModel.employedContractSecondHeadlineModel;
    };
    /**
     * Inicializa el parámetro employedContractSecondHeadlineModel igual employedContractSecondHeadlineModel
     *
     * *Sets employedContractSecondHeadlineModel parameter equal to employedContractSecondHeadlineModel*
     *
     * @param {employedContractSecondHeadlineModel} employedContractSecondHeadlineModel
     */
    AbreCuentasService.prototype.setEmployedContractSecondHeadlineModel = function (employedContractSecondHeadlineModel) {
        this.abreCuentasModel.employedContractSecondHeadlineModel =
            employedContractSecondHeadlineModel;
    };
    /**
     * Obtiene la lista CONTRACTS_LIST, donde están los tipos de contratos laborales para que el usuario escoja
     *
     * *Get CONTRACTS_LIST list there are different types of labor contracts that user must choose*
     *
     * @returns {TypeContractModel[]} *CONTRACTS_LIST*
     */
    AbreCuentasService.prototype.getListTypeContract = function () {
        return CONTRACTS_LIST;
    };
    /**
     * Inicializa errorProperty() partiendo de errorInfo proporcionado por la variable code
     *
     * *Sets errorProperty() from errorInfo given by code variable*
     *
     * @param {string} code
     */
    AbreCuentasService.prototype.caseInfoError = function (code) {
        if (code === '200') {
            return;
        }
        // tslint:disable-next-line: no-duplicate-case
        switch (code) {
            case ERROR_111.CODE:
                this.errorInfo = ERROR_111.DATA;
                // this.errorInfo.image = this.getImageLottieError();
                break;
            case ERROR_112.CODE:
                this.errorInfo = ERROR_112.DATA;
                // this.errorInfo.image = this.getImageLottieError();
                break;
            case ERROR_113.CODE:
                this.errorInfo = ERROR_113.DATA;
                // this.errorInfo.image = this.getImageLottieError();
                break;
            case ERROR_102.CODE:
                this.errorInfo =
                    this.chanelid == CHANNEL.PORTALO.CODE
                        ? ERROR_133.DATA
                        : ERROR_102.DATA;
                break;
            case ERROR_103.CODE:
                this.errorInfo = ERROR_103.DATA;
                break;
            case ERROR_104.CODE:
                this.errorInfo = ERROR_104.DATA;
                break;
            case ERROR_105.CODE:
                console.log('this.chanelid', this.chanelid);
                this.errorInfo =
                    this.chanelid == CHANNEL.PORTALO.CODE
                        ? ERROR_133.DATA
                        : ERROR_105.DATA;
                this.errorInfo.title = this.helperService.stringFormat(ERROR_105.DATA.title, this.getDocumentInfo().firstname);
                break;
            case ERROR_107.CODE:
                this.errorInfo = ERROR_107.DATA;
                if (this.getIsErrorPco()) {
                    this.errorInfo = ERROR_0104.DATA;
                    this.setIsErrorPco(false);
                }
                break;
            case ERROR_108.CODE:
                this.errorInfo = ERROR_108.DATA;
                break;
            case ERROR_121.CODE:
                this.errorInfo = ERROR_121.DATA;
                break;
            case ERROR_401.CODE:
                this.errorInfo = ERROR_401.DATA;
                break;
            case ERROR_122.CODE:
                this.errorInfo = ERROR_122.DATA;
                this.errorInfo.title = this.helperService.stringFormat(ERROR_122.DATA.title, this.getDocumentInfo().firstname);
                break;
            case ERROR_123.CODE:
                this.errorInfo = ERROR_123.DATA;
                this.errorInfo.title = this.helperService.stringFormat(ERROR_123.DATA.title, this.getDocumentInfo().firstname);
                break;
            case ERROR_124.CODE:
                this.errorInfo = ERROR_124.DATA;
                break;
            case ERROR_125.CODE:
                this.errorInfo = ERROR_125.DATA;
                break;
            case ERROR_126.CODE:
                this.errorInfo = ERROR_126.DATA;
                this.errorInfo.title = this.helperService.stringFormat(ERROR_126.DATA.title, this.getDocumentInfo().firstname);
                break;
            case ERROR_127.CODE:
                this.errorInfo = ERROR_127.DATA;
                break;
            case ERROR_128.CODE:
                this.errorInfo = ERROR_128.DATA;
                this.errorInfo.title = this.helperService.stringFormat(ERROR_128.DATA.title, this.getDocumentInfo().firstname);
                break;
            case ERROR_129.CODE:
                this.errorInfo = ERROR_129.DATA;
                break;
            case ERROR_130.CODE:
                this.errorInfo = ERROR_130.DATA;
                var specificInfo = this.errorInfo.specificInfo;
                // tslint:disable-next-line: early-exit
                if (specificInfo !== undefined) {
                    specificInfo.value = this.helperService.stringFormat(ERROR_130.DATA.specificInfo.value, this.getSolicitationId());
                }
                break;
            case ERROR_500.CODE:
                this.errorInfo = ERROR_500.DATA;
                break;
            case ERROR_501.CODE:
                this.errorInfo = ERROR_501.DATA;
                break;
            case ERROR_502.CODE:
                var second_headline = this.getSecondHeadline();
                var selectedOccupation = typeof second_headline === 'undefined' ||
                    !second_headline.has_second_headline
                    ? this.getOccupationSelected()
                    : this.getOccupationSelectedSecondHeadline();
                this.errorInfo.buttonLabel =
                    this.copiesService.copies.error_back_to_edit_date_end;
                this.errorInfo.type = 'date-error';
                if (selectedOccupation.id === 1) {
                    var type_contract = typeof second_headline === 'undefined' ||
                        !second_headline.has_second_headline
                        ? this.getEmployedContractModel()
                        : this.getEmployedContractSecondHeadlineModel();
                    this.errorInfo.title = this.helperService.stringFormat(ERROR_502.DATA.title, type_contract.typeContract.timeText.toString());
                    this.errorInfo.buttonAction = '$exit';
                    this.errorInfo.description = this.helperService.stringFormat(ERROR_502.DATA.description, type_contract.typeContract.timeText.toString());
                    break;
                }
                this.errorInfo.title = this.helperService.stringFormat(ERROR_502.DATA.title, this.copiesService.copies.independent_occupation.title_date_error);
                this.errorInfo.description = this.helperService.stringFormat(ERROR_502.DATA.description, this.copiesService.copies.independent_occupation.title_date_error);
                break;
            case ERROR_512.CODE:
                this.errorInfo = ERROR_512.DATA;
                break;
            case ERROR_514.CODE:
                this.errorInfo = ERROR_514.DATA;
                break;
            case ERROR_DBS.CODE:
                this.errorInfo = ERROR_DBS.DATA;
                this.errorInfo.description = this.helperService.stringFormat(ERROR_105.DATA.title, this.abreCuentasModel.dsbSecurityCheckException);
                break;
            case ERROR_BRANCH.CODE_1:
            case ERROR_BRANCH.CODE_2:
            case ERROR_BRANCH.CODE_3:
                this.errorInfo = ERROR_BRANCH.DATA;
                break;
            case ERROR_600.CODE:
                this.errorInfo = ERROR_600.DATA;
                break;
            case ERROR_601.CODE:
                this.errorInfo = ERROR_601.DATA;
                break;
            case ERROR_602.CODE:
                this.errorInfo = ERROR_602.DATA;
                break;
            case ERROR_603.CODE:
                this.errorInfo = ERROR_603.DATA;
                break;
            case ERROR_NONE.CODE:
                this.errorInfo = ERROR_NONE.DATA;
                break;
            case ERROR_404.CODE:
                this.errorInfo = ERROR_404.DATA;
                break;
            case ERROR_403.CODE:
                this.errorInfo = ERROR_403.DATA;
                break;
            case ERROR_TECH.CODE:
                this.errorInfo = ERROR_TECH.DATA;
                break;
            case ERROR_400.CODE:
                this.errorInfo = ERROR_400.DATA;
                break;
            case ERROR_402.CODE:
                this.errorInfo = ERROR_402.DATA;
                break;
            case ERROR_131.CODE:
                this.errorInfo = ERROR_131.DATA;
                break;
            case ERROR_132.CODE:
                this.errorInfo = ERROR_132.DATA;
                break;
            case ERROR_LIB.CODE:
                this.errorInfo = ERROR_LIB.DATA;
                break;
            case ERROR_142.CODE:
                this.errorInfo = ERROR_142.DATA;
                break;
            case ERROR_140.CODE:
                this.errorInfo = ERROR_140.DATA;
                break;
            case ERROR_141.CODE:
                this.errorInfo = ERROR_141.DATA;
                break;
            case ERROR_134.CODE:
                this.errorInfo = ERROR_134.DATA;
                break;
            case ERROR_135.CODE:
                this.errorInfo = ERROR_135.DATA;
                break;
            case ERROR_137.CODE:
                this.errorInfo = ERROR_137.DATA;
                var specificInfo2 = this.errorInfo.specificInfo;
                // tslint:disable-next-line: early-exit
                if (specificInfo2 !== undefined) {
                    specificInfo2.value = this.helperService.stringFormat(ERROR_137.DATA.specificInfo.value, this.getSolicitationId());
                }
                break;
            case ERROR_136.CODE:
                this.errorInfo = ERROR_136.DATA;
                var specificInfo3 = this.errorInfo.specificInfo;
                // tslint:disable-next-line: early-exit
                if (specificInfo3 !== undefined) {
                    specificInfo3.value = this.helperService.stringFormat(ERROR_137.DATA.specificInfo.value, this.getSolicitationId());
                }
                break;
            case ERROR_138.CODE:
                this.errorInfo = ERROR_138.DATA;
                var specificInfo4 = this.errorInfo.specificInfo;
                // tslint:disable-next-line: early-exit
                if (specificInfo4 !== undefined) {
                    specificInfo4.value = this.helperService.stringFormat(ERROR_138.DATA.specificInfo.value, this.getSolicitationId());
                }
                break;
            case ERROR_139.CODE:
                this.errorInfo = ERROR_139.DATA;
                break;
            case ERROR_143.CODE:
                this.errorInfo = ERROR_143.DATA;
                var specificInfo5 = this.errorInfo.specificInfo;
                // tslint:disable-next-line: early-exit
                if (specificInfo5 !== undefined) {
                    specificInfo5.value = this.helperService.stringFormat(ERROR_143.DATA.specificInfo.value, this.getSolicitationId());
                }
                break;
            case ERROR_999.CODE:
                this.errorInfo = ERROR_999.DATA;
                // this.errorInfo.image = this.getImageLottieError();
                break;
            default:
                break;
        }
        this.setErrorProperty(this.errorInfo);
        console.log('----->', this.getErrorProperty());
    };
    /**
     * Obtiene la lista occupationSelected
     *
     * *Gets occupationSelectedT list*
     *
     * @returns {OccupationModel} this.abreCuentasModel.occupationSelected
     */
    AbreCuentasService.prototype.getOccupationSelected = function () {
        return this.abreCuentasModel.occupationSelected;
    };
    /**
     * Obtiene la lista occupationSelected
     *
     * *Gets occupationSelectedT list*
     *
     * @returns {OccupationSecondHeadlineModel} this.abreCuentasModel.occupationSelected
     */
    AbreCuentasService.prototype.getOccupationSelectedSecondHeadline = function () {
        return this.abreCuentasModel.occupationSelectedSecondHeadline;
    };
    /**
     * Inicializa el parámetro occupationSelected igual occupation
     *
     * *Sets occupationSelected parameter equal to occupation*
     *
     * @param {any} occupation
     */
    AbreCuentasService.prototype.setOccupationSelected = function (occupation) {
        console.log(occupation);
        this.abreCuentasModel.occupationSelected = occupation;
    };
    /**
     * Inicializa el parámetro occupationSelected igual occupation
     *
     * *Sets occupationSelected parameter equal to occupation*
     *
     * @param {any} occupation
     */
    AbreCuentasService.prototype.setOccupationSelectedSecondHeadline = function (occupation) {
        this.abreCuentasModel.occupationSelectedSecondHeadline = occupation;
    };
    /**
     * Obtiene el parámetro de officeModel[index]
     *
     * *Gets officeModel[index] parameter*
     *
     * @param {string}  index
     * @returns {OfficeModel} this.abreCuentasModel.officeModel[index]
     */
    AbreCuentasService.prototype.getOfficeInfo = function (index) {
        var officeInfo = this.abreCuentasModel.officeModel[index];
        if (officeInfo) {
            return officeInfo;
        }
        return {
            occupation_id: 0,
            company_name: '',
            company_nameInput: '',
            address: {
                city: new CityModel(),
                address: '',
                detail: '',
                addressInput: '',
            },
            office_number: '',
        };
    };
    /**
     * Inicializa el parámetro officeModel[index] igual officeModel
     *
     * *Sets officeModel[index] parameter equal to officeModel*
     *
     * @param {string} index
     * @param {OfficeModel} officeModel
     */
    AbreCuentasService.prototype.setOfficeInfo = function (index, officeModel) {
        this.abreCuentasModel.officeModel[index] = officeModel;
    };
    /**
     * Obtiene el parámetro de OfficeSecondHeadlineModel[index]
     *
     * *Gets OfficeSecondHeadlineModel[index] parameter*
     *
     * @param {string}  index
     * @returns {OfficeSecondHeadlineModel} this.abreCuentasModel.OfficeSecondHeadlineModel[index]
     */
    AbreCuentasService.prototype.getOfficeSecondHeadlineInfo = function (index) {
        var officeInfo = this.abreCuentasModel.officeSecondHeadlineModel[index];
        if (officeInfo) {
            return officeInfo;
        }
        return {
            occupation_id: 0,
            company_name: '',
            company_nameInput: '',
            address: {
                city: new CityModel(),
                address: '',
                detail: '',
                addressInput: '',
            },
            office_number: '',
        };
    };
    /**
     * Inicializa el parámetro OfficeSecondHeadlineModel[index] igual OfficeSecondHeadlineModel
     *
     * *Sets OfficeSecondHeadlineModel[index] parameter equal to OfficeSecondHeadlineModel*
     *
     * @param {string} index
     * @param {OfficeSecondHeadlineModel} OfficeSecondHeadlineModel
     */
    AbreCuentasService.prototype.setOfficeSecondHeadlineInfo = function (index, officeSecondHeadlineModel) {
        this.abreCuentasModel.officeSecondHeadlineModel[index] =
            officeSecondHeadlineModel;
    };
    /**
     * Obtiene el parámetro de LiveAbroadModel
     *
     * *Gets LiveAbroadModel parameter*
     *
     * @returns {LiveAbroadModel} this.abreCuentasModel.LiveAbroadModel
     */
    AbreCuentasService.prototype.getLiveAbroad = function () {
        return this.abreCuentasModel.LiveAbroadModel;
    };
    /**
     * Inicializa el parámetro LiveAbroadModel igual liveAbroadModel
     *
     * *Sets LiveAbroadModel  parameter equal to liveAbroadModel*
     *
     * @param {LiveAbroadModel} liveAbroadModel
     */
    AbreCuentasService.prototype.setLiveAbroad = function (liveAbroadModel) {
        this.abreCuentasModel.LiveAbroadModel = liveAbroadModel;
    };
    /**
     * Obtiene el parámetro de foreignCurrencyModel
     *
     * *Gets foreignCurrencyModel*
     *
     * @returns {ForeignCurrencyModel} *this.abreCuentasModel.foreignCurrencyModel*
     */
    AbreCuentasService.prototype.getForeignCurrency = function () {
        return this.abreCuentasModel.foreignCurrencyModel;
    };
    /**
     * Inicializa el parámetro foreignCurrencyModel igual foreignCurrencyModel
     *
     * *Sets foreignCurrencyModel  parameter equal to foreignCurrencyModel*
     *
     * @param {ForeignCurrencyModel} foreignCurrencyModel
     */
    AbreCuentasService.prototype.setForeignCurrency = function (foreignCurrencyModel) {
        this.abreCuentasModel.foreignCurrencyModel = foreignCurrencyModel;
    };
    /**
     * Obtiene la lista parámetro de operationCurrencyList
     *
     * *Gets operationCurrencyList list*
     *
     * @returns {any[]} this.abreCuentasModel.operationCurrencyList
     */
    AbreCuentasService.prototype.getOperationCurrencyList = function () {
        return this.abreCuentasModel.operationCurrencyList;
    };
    /**
     * Inicializa el parámetro operationCurrencyList igual operationCurrencyList
     *
     * *Sets operationCurrencyList  parameter equal to operationCurrencyList*
     *
     *  @param {any} operationCurrencyList
     */
    AbreCuentasService.prototype.setOperationCurrencyList = function (operationCurrencyList) {
        this.abreCuentasModel.operationCurrencyList = operationCurrencyList;
    };
    /**
     * Obtiene el parámetro de foreignProductsSelected
     *
     * *Gets foreignProductsSelected parameter*
     *
     * @returns {LiveAbroadModel} this.abreCuentasModel.foreignProductsSelected
     */
    AbreCuentasService.prototype.getForeignSelected = function () {
        return this.abreCuentasModel.foreignProductsSelected;
    };
    /**
     * Inicializa el foreignProductsSelected igual foreignProductsSelected
     *
     * *Sets foreignProductsSelected  parameter equal to foreignProductsSelected*
     *
     * @param {LiveAbroadModel} foreignProductsSelected
     */
    AbreCuentasService.prototype.setForeignSelected = function (foreignProductsSelected) {
        this.abreCuentasModel.foreignProductsSelected = foreignProductsSelected;
    };
    /**
     * Obtiene el parámetro de selectedShippingMethod
     *
     * *Gets selectedShippingMethod parameter*
     *
     * @returns {ObjectCheckModel} *this.abreCuentasModel.selectedShippingMethod
     */
    AbreCuentasService.prototype.getselectedShippingMethod = function () {
        return this.abreCuentasModel.selectedShippingMethod;
    };
    /**
     * Inicializa el parámetro selectedShippingMethod igual selectedShippingMethod
     *
     * *Sets selectedShippingMethod  parameter equal to selectedShippingMethod*
     *
     * @param {ObjectCheckModel} selectedShippingMethod
     */
    AbreCuentasService.prototype.setselectedShippingMethod = function (selectedShippingMethod) {
        this.abreCuentasModel.selectedShippingMethod = selectedShippingMethod;
    };
    /**
     * Obtiene la lista de cityList
     *
     * *Gets cityList list*
     *
     * @returns {any[]} this.abreCuentasModel.cityList
     */
    AbreCuentasService.prototype.getCityList = function () {
        return this.abreCuentasModel.cityList;
    };
    /**
     * Inicializa el parámetro cityList igual cityList
     *
     * *Sets cityList  parameter equal to cityList*
     *
     * @param {any} cityList
     */
    AbreCuentasService.prototype.setCityList = function (cityList) {
        this.abreCuentasModel.cityList = cityList;
    };
    /**
     * Obtiene el parámetro de ciiuModel seleccionado, actividad económica
     *
     * *Gets ciiuModel selected parameter, economical activity*
     *
     * @returns {CiiuModel} this.abreCuentasModel.ciiuModel
     */
    AbreCuentasService.prototype.getCiiuSelected = function () {
        return this.abreCuentasModel.ciiuModel;
    };
    /**
     * Inicializa el parámetro ciiuModel seleccionado igual ciiuModel
     *
     * *Sets ciiuModel selected parameter equal to ciiuModel*
     *
     * @param {CiiuModel} ciiuModel
     */
    AbreCuentasService.prototype.setCiiuSelected = function (ciiuModel) {
        this.abreCuentasModel.ciiuModel = ciiuModel;
    };
    /**
     * Obtiene el parámetro de ciiuModel seleccionado, actividad económica Segundo titular
     *
     * *Gets ciiuModel selected parameter, economical activity Second Headline*
     *
     * @returns {CiiuSecondModel} this.abreCuentasModel.ciiuecondModel
     */
    AbreCuentasService.prototype.getSecondCiiuSelected = function () {
        return this.abreCuentasModel.ciiuSecondModel;
    };
    /**
     * Inicializa el parámetro ciiuModel seleccionado igual ciiuModel
     *
     * *Sets ciiuModel selected parameter equal to ciiuModel*
     *
     * @param {CiiuSecondModel} ciiuModel
     */
    AbreCuentasService.prototype.setSecondCiiuSelected = function (ciiuModel) {
        this.abreCuentasModel.ciiuSecondModel = ciiuModel;
    };
    /**
     * Obtiene el parámetro de ciiuDate
     * *Gets ciiuDate parameter*
     *
     * @returns {string} ciiuDate
     */
    AbreCuentasService.prototype.getCiiuDate = function () {
        return this.abreCuentasModel.ciiuDate;
    };
    /**
     * Inicializa el parámetro ciiuDate igual ciiuDate
     *
     * *Sets ciiuDate  parameter equal to ciiuDate*
     *
     * @param {string} ciiuDate
     */
    AbreCuentasService.prototype.setCiiuDate = function (ciiuDate) {
        this.abreCuentasModel.ciiuDate = ciiuDate;
    };
    /**
     * Obtiene el parámetro de ciiuDate
     * *Gets ciiuDate parameter*
     *
     * @returns {string} ciiuDate
     */
    AbreCuentasService.prototype.getSecondCiiuDate = function () {
        return this.abreCuentasModel.ciiuSecondDate;
    };
    /**
     * Inicializa el parámetro ciiuDate igual ciiuDate
     *
     * *Sets ciiuDate  parameter equal to ciiuDate*
     *
     * @param {string} ciiuSecondDate
     */
    AbreCuentasService.prototype.setSecondCiiuDate = function (ciiuDate) {
        this.abreCuentasModel.ciiuSecondDate = ciiuDate;
    };
    /**
     * Obtiene el parámetro de citySearchSelected
     *
     * *Gets citySearchSelected parameter*
     *
     * @returns {CityModel} citySearchSelected
     */
    AbreCuentasService.prototype.getCitySearchSelected = function () {
        return this.abreCuentasModel.citySearchSelected;
    };
    /**
     * Inicializa el parámetro citySearchSelected igual citySearchSelected
     *
     * *Sets citySearchSelected  parameter equal to citySearchSelected*
     *
     * @param {CityModel} citySearchSelected
     */
    AbreCuentasService.prototype.setCitySearchSelected = function (citySearchSelected) {
        this.abreCuentasModel.citySearchSelected = citySearchSelected;
    };
    /**
     * Obtiene el parámetro de incomesOriginSearchSelected
     *
     * *Gets incomesOriginSearchSelected parameter*
     *
     * @returns {CityModel} this.abreCuentasModel.incomesOriginSearchSelected
     */
    AbreCuentasService.prototype.getIncomesOriginSearchSelected = function () {
        return this.abreCuentasModel.incomesOriginSearchSelected;
    };
    /**
     * Inicializa el parámetro originSearchSelected igual originSearchSelected
     *
     * *Sets originSearchSelected  parameter equal to originSearchSelected*
     *
     * @param {IncomesOriginModel} originSearchSelected
     */
    AbreCuentasService.prototype.setIncomesOriginSearchSelected = function (originSearchSelected) {
        this.abreCuentasModel.incomesOriginSearchSelected = originSearchSelected;
    };
    /**
     * Obtiene el parámetro de incomesOriginSecondHeadlineSelected
     *
     * *Gets incomesOriginSecondHeadlineSelected parameter*
     *
     * @returns {CityModel} this.abreCuentasModel.incomesOriginSecondHeadlineSelected
     */
    AbreCuentasService.prototype.getIncomesOriginSecondHeadlineSearchSelected = function () {
        return this.abreCuentasModel.incomesOriginSecondHeadlineSelected;
    };
    /**
     * Inicializa el parámetro originSecondHeadlineSearchSelected igual originSecondHeadlineSearchSelected
     *
     * *Sets originSecondHeadlineSearchSelected  parameter equal to originSecondHeadlineSearchSelected*
     *
     * @param {IncomesOriginSecondHeadlineModel} originSecondHeadlineSearchSelected
     */
    AbreCuentasService.prototype.setIncomesOriginSecondHeadlineSearchSelected = function (originSecondHeadlineSearchSelected) {
        this.abreCuentasModel.incomesOriginSecondHeadlineSelected =
            originSecondHeadlineSearchSelected;
    };
    /**
     * Obtiene el parámetro de agencySelected
     *
     * *Gets agencySelected parameter*
     *
     * @returns {AgencyModel} this.abreCuentasModel.agencySelected
     */
    AbreCuentasService.prototype.getAgencySelected = function () {
        return this.abreCuentasModel.agencySelected;
    };
    /**
     * Inicializa el parámetro agencySelected igual agencySelected
     *
     * *Sets agencySelected  parameter equal to agencySelected*
     *
     * @param {AgencyModel} agencySelected
     */
    AbreCuentasService.prototype.setAgencySelected = function (agencySelected) {
        this.abreCuentasModel.agencySelected = agencySelected;
    };
    /**
     * Obtiene el parámetro de agencySelected
     *
     * *Gets agencySelected parameter*
     *
     * @returns {AgencyModel} this.abreCuentasModel.agencySelected
     */
    AbreCuentasService.prototype.getDisbursementAgencySelected = function () {
        return this.abreCuentasModel.disbursementAgencySelected;
    };
    /**
     * Inicializa el parámetro agencySelected igual agencySelected
     *
     * *Sets agencySelected  parameter equal to agencySelected*
     *
     * @param {AgencyModel} agencySelected
     */
    AbreCuentasService.prototype.setDisbursementAgencySelected = function (agencySelected) {
        this.abreCuentasModel.disbursementAgencySelected = agencySelected;
    };
    /**
     * Obtiene el parámetro de checkboxInfoIncomesChecked
     *
     * *Gets checkboxInfoIncomesChecked parameter*
     *
     * @returns {CheckboxModel} this.abreCuentasModel.checkboxInfoIncomesChecked
     */
    AbreCuentasService.prototype.getcheckboxInfoIncomesChecked = function () {
        return this.abreCuentasModel.checkboxInfoIncomesChecked;
    };
    /**
     * Inicializa el parámetro checkboxInfoIncomesChecked igual checkboxInfoIncomesChecked
     *
     * *Sets checkboxInfoIncomesChecked  parameter equal to checkboxInfoIncomesChecked*
     *
     * @param {CheckboxModel} checkboxInfoIncomesChecked
     */
    AbreCuentasService.prototype.setcheckboxInfoIncomesChecked = function (checkboxInfoIncomesChecked) {
        this.abreCuentasModel.checkboxInfoIncomesChecked =
            checkboxInfoIncomesChecked;
    };
    /**
     * Obtiene el parámetro de infoInferredIncomes
     *
     * *Gets infoInferredIncomes parameter*
     *
     * @returns {any} this.abreCuentasModel.infoInferredIncomes
     */
    AbreCuentasService.prototype.getinfoInferredIncomes = function () {
        return this.abreCuentasModel.infoInferredIncomes;
    };
    /**
     * Inicializa el parámetro infoInferredIncomes igual infoInferredIncomes
     *
     * *Sets infoInferredIncomes  parameter equal to infoInferredIncomes*
     *
     * @param {any} infoInferredIncomes
     */
    AbreCuentasService.prototype.setinfoInferredIncomes = function (infoInferredIncomes) {
        this.abreCuentasModel.infoInferredIncomes = infoInferredIncomes;
    };
    AbreCuentasService.prototype.getSegmentID = function () {
        return this.getPostlogin()
            ? this.getCustomerData().basic.sub_segment_id
            : this.getinfoInferredIncomes().segment_id;
    };
    /**
     * Obtiene el parámetro de infoIp
     * *Gets infoIp parameter*
     *
     * @returns {string} this.abreCuentasModel.infoIp
     */
    AbreCuentasService.prototype.getinfoIp = function () {
        return this.abreCuentasModel.infoIp;
    };
    /**
     * Inicializa el parámetro infoIp igual infoIp
     *
     * *Sets infoIp  parameter equal to infoIp*
     *
     * @param {any} infoIp
     */
    AbreCuentasService.prototype.setinfoIp = function (infoIp) {
        this.abreCuentasModel.infoIp = infoIp;
    };
    /**
     * Obtiene el parámetro de agreementSelected
     *
     * *Gets agreementSelected parameter*
     *
     * @returns {AgreementsModel} this.abreCuentasModel.agreementSelected
     */
    AbreCuentasService.prototype.getAgreementSelected = function () {
        return this.abreCuentasModel.agreementSelected;
    };
    /**
     * Inicializa el parámetro agreementSelected igual agreementSelected
     *
     * *Sets agreementSelected  parameter equal to agreementSelected*
     *
     * @param {AgreementsModel} agreementSelected
     */
    AbreCuentasService.prototype.setAgreementSelected = function (agreementSelected) {
        this.abreCuentasModel.agreementSelected = agreementSelected;
    };
    /**
     * Obtiene el parámetro de abreCuentasConfigs
     *
     * *Gets abreCuentasConfigs parameter*
     *
     * @returns {[id: string]} this.abreCuentasModel.abreCuentasConfigs
     */
    AbreCuentasService.prototype.getAbreCuentasConfigs = function () {
        return this.abreCuentasModel.abreCuentasConfigs;
    };
    /**
     * Inicializa el parámetro abreCuentasConfigs igual abreCuentasConfigs
     *
     * *Sets abreCuentasConfigs  parameter equal to abreCuentasConfigs*
     *
     * @param {any} abreCuentasConfigs
     */
    AbreCuentasService.prototype.setAbreCuentasConfigs = function (abreCuentasConfigs) {
        this.abreCuentasModel.abreCuentasConfigs = abreCuentasConfigs;
    };
    /**
     * Obtiene el parámetro de productSelected
     *
     * *Gets productSelected parameter*
     *
     * @returns {IProductsModel} this.abreCuentasModel.productSelected
     */
    AbreCuentasService.prototype.getproductSelected = function () {
        return this.abreCuentasModel.productSelected;
    };
    /**
     * Inicializa el parámetro productSelected igual productSelected
     *
     * *Sets productSelected  parameter equal to productSelected*
     *
     * @param {any} productSelected
     */
    AbreCuentasService.prototype.setproductSelected = function (productSelected) {
        this.abreCuentasModel.productSelected = productSelected;
    };
    /**
     * Inicializa el parámetro deviceInfo igual deviceInfo
     *
     * *Sets deviceInfo  parameter equal to deviceInfo*
     *
     * @param {LogDeviceModel} deviceInfo
     */
    AbreCuentasService.prototype.setdeviceInfo = function (deviceInfo) {
        this.abreCuentasModel.deviceInfo = deviceInfo;
    };
    /**
     * Obtiene el parámetro de deviceInfo
     *
     * *Gets deviceInfo parameter*
     *
     * @returns {LogDeviceModel} this.abreCuentasModel.deviceInfo
     */
    AbreCuentasService.prototype.getdeviceInfo = function () {
        return this.abreCuentasModel.deviceInfo;
    };
    /**
     * Obtiene el parámetro de paydayProductModel
     *
     * *Gets paydayProductModel parameter*
     *
     * @returns {PayDayProductModel}  this.abreCuentasModel.paydayProductModel
     */
    AbreCuentasService.prototype.getPayDayProductSelected = function () {
        return this.abreCuentasModel.paydayProductModel;
    };
    /**
     * Inicializa el parámetro paydayProductModel igual paydayProductModel
     *
     * *Sets paydayProductModel  parameter equal to paydayProductModel*
     *
     * @param {PayDayProductModel} paydayProductModel
     */
    AbreCuentasService.prototype.setPayDayProductSelected = function (paydayProductModel) {
        this.abreCuentasModel.paydayProductModel = paydayProductModel;
    };
    /**
     * Se optienen el párametro de configValuesModel
     * @returns {ConfigValuesModel} this.abreCuentasModel.configValuesModel
     */
    AbreCuentasService.prototype.getConfigurationValues = function () {
        return this.abreCuentasModel.configValuesModel;
    };
    /**
     * Inicializa el parámetro configValuesModel
     * @param {ConfigValuesModel} configValuesModel
     */
    AbreCuentasService.prototype.setConfigurationValues = function (configValuesModel) {
        this.abreCuentasModel.configValuesModel = configValuesModel;
    };
    /**
     * Obtiene el parámetro de virtualCardfFranchiseModel
     *
     * *Gets VirtualCardFranchiseModel parameter*
     *
     * @returns {VirtualCardfranchiseModel}  this.abreCuentasModel.virtualCardFranchiseModel
     */
    AbreCuentasService.prototype.getVirtualCardFranchise = function () {
        return this.abreCuentasModel.virtualCardFranchiseModel;
    };
    /**
     * Inicializa el parámetro virtualCardFranchiseModel igual virtualCardfranchiseModel
     *
     * *Sets virtualCardFranchiseModel  parameter equal to virtualCardFranchiseModel*
     *
     * @param {VirtualCardFranchiseModel} virtualCardFranchiseModel
     */
    AbreCuentasService.prototype.setVirtualCardFranchise = function (virtualCardFranchiseModel) {
        this.abreCuentasModel.virtualCardFranchiseModel = virtualCardFranchiseModel;
    };
    /**
     * Obtiene el parámetro de contactAdressConfigTc
     *
     * *Gets contactAdressConfigTc parameter*
     *
     * @returns {AddressModel} this.abreCuentasModel.contactAdressConfigTc
     */
    AbreCuentasService.prototype.getAddressInfoConfigTc = function () {
        return this.abreCuentasModel.contactAdressConfigTc;
    };
    /**
     * Inicializa el parámetro contactAdressConfigTc igual contactAdressConfigTc
     *
     * *Sets contactAdressConfigTc  parameter equal to contactAdressConfigTc*
     *
     * @param {AddressModel} contactAdressConfigTc
     */
    AbreCuentasService.prototype.setAddressInfoConfigTc = function (contactAdressConfigTc) {
        this.abreCuentasModel.contactAdressConfigTc = contactAdressConfigTc;
    };
    AbreCuentasService.prototype.setAmout = function (typeProduct, amount) {
        this.abreCuentasModel.pcoModel.granted_product_multi.forEach(function (product) {
            if (product.product_type === typeProduct) {
                product.limit_amount.amount = amount;
            }
        });
    };
    AbreCuentasService.prototype.setEditProduct = function (typeProduct) {
        this.typeProduct = typeProduct;
    };
    AbreCuentasService.prototype.getEditProduct = function () {
        return this.typeProduct;
    };
    AbreCuentasService.prototype.getAmout = function (typeProduct) {
        var dataProduct = this.abreCuentasModel.pcoModel.granted_product_multi.find(function (product) { return product.product_type === typeProduct; });
        return dataProduct === undefined ? ' ' : dataProduct.limit_amount.amount;
    };
    /**
     * Obtiene el parámetro de contactAdressConfigTc
     * *Gets contactAdressConfigTc parameter*
     *
     * @returns {AddressModel} this.abreCuentasModel.contactAdressConfigTc
     */
    AbreCuentasService.prototype.getAddtionalAddressConfigTcList = function () {
        return this.abreCuentasModel.addressTcConfigList;
    };
    /**
     * Inicializa el parámetro addressTcConfigListcon una lista de direcciones
     * *Sets contactAdressConfigTc  parameter eaual to address list*
     *
     * @param {AddressModel} addressTcConfigList
     */
    AbreCuentasService.prototype.setAddtionalAddressConfigTcList = function (addtionalAddressConfigTcList) {
        this.abreCuentasModel.addressTcConfigList = addtionalAddressConfigTcList;
    };
    /**
     * Obtiene la lista de agreementList
     *
     * *Gets agreementList list*
     *
     * @returns {AgreementsModel[]} this.abreCuentasModel.agreementList
     */
    AbreCuentasService.prototype.getAgreementList = function () {
        return this.abreCuentasModel.agreementList;
    };
    /**
     * Inicializa la lista agreementList igual agreementList
     *
     * *Sets agreementList  list equal to agreementList*
     *
     * @param {AgreementsModel[]} agreementList
     */
    AbreCuentasService.prototype.setAgreementList = function (agreementList) {
        this.abreCuentasModel.agreementList = agreementList;
    };
    /**
     * Obtiene el parámetro de ProspectResponse
     *
     * *Gets ProspectResponse parameter*
     *
     * @returns {any} this.abreCuentasModel.ProspectResponse
     */
    AbreCuentasService.prototype.getProspectResponse = function () {
        return this.abreCuentasModel.ProspectResponse;
    };
    /**
     * Inicializa el parámetro ProspectResponse igual ProspectResponse
     *
     * *Sets ProspectResponse  parameter equal to ProspectResponse*
     *
     * @param {any} ProspectResponse
     */
    AbreCuentasService.prototype.setProspectResponse = function (ProspectResponse) {
        this.abreCuentasModel.ProspectResponse = ProspectResponse;
    };
    /**
     * Inicializa el parámetro ProspectResponseSecondHeadLine igual ProspectResponseSecondHeadLine
     *
     * *Sets ProspectResponseSecondHeadLine  parameter equal to ProspectResponseSecondHeadLine*
     *
     * @param {any} ProspectResponseSecondHeadLine
     */
    AbreCuentasService.prototype.setProspectResponseSecondHeadLine = function (ProspectResponseSecondHeadLine) {
        this.abreCuentasModel.ProspectResponseSecondHeadLine =
            ProspectResponseSecondHeadLine;
    };
    /**
     * Obtiene el parámetro de ProspectResponse
     *
     * *Gets ProspectResponseSecondHeadLine parameter*
     *
     * @returns {any} this.abreCuentasModel.ProspectResponse
     */
    AbreCuentasService.prototype.getProspectResponseSecondHeadLine = function () {
        return this.abreCuentasModel.ProspectResponseSecondHeadLine;
    };
    /**
     * Inicializa la lista benefitsList igual benefitsList
     *
     * *Sets benefitsList  list equal to benefitsList*
     *
     * @param {any} benefitsList
     */
    AbreCuentasService.prototype.setBenefitsList = function (benefitsList) {
        this.abreCuentasModel.benefitsList = benefitsList;
    };
    /**
     * Obtiene la lista de benefitsList
     *
     * *Gets benefitsList list*
     *
     * @returns {string} this.abreCuentasModel.benefitsList
     */
    AbreCuentasService.prototype.getBenefitsList = function () {
        return this.abreCuentasModel.benefitsList;
    };
    /**
     * Inicializa el parámetro customerData igual a customerData
     *
     * *Sets customerData parameter equal to customerData*
     *
     * @param {any} customerData
     */
    AbreCuentasService.prototype.setCustomerData = function (customerData) {
        this.abreCuentasModel.customerData = customerData;
    };
    /**
     * Obtiene el parámetro de customerData
     *
     * *Gets customerData parameter*
     *
     * @returns {any} this.abreCuentasModel.customerData
     */
    AbreCuentasService.prototype.getCustomerData = function () {
        return this.abreCuentasModel.customerData;
    };
    /**
     * Inicializa el parámetro pcoModel.granted_product.limit_amount.amount igual a amountPcoAproved
     *
     * *Sets pcoModel.granted_product.limit_amount.amount parameter equal to amountPcoAproved*
     *
     *  @param {number} amountPcoAproved
     */
    AbreCuentasService.prototype.setAmountPcoAproved = function (amountPcoAproved) {
        this.abreCuentasModel.pcoModel.granted_product.limit_amount.amount =
            amountPcoAproved;
    };
    /**
     * Obtiene el parámetro de pcoModel.granted_product.limit_amount.amount
     *
     * *Gets pcoModel.granted_product.limit_amount.amount parameter*
     *
     * @returns {number} this.abreCuentasModel.pcoModel.granted_product.limit_amount.amount*
     */
    AbreCuentasService.prototype.getAmountPcoAproved = function () {
        return this.abreCuentasModel.pcoModel.granted_product.limit_amount.amount;
    };
    /**
     * Obtiene el parámetro de pcoModel.granted_product_multi.limit_amount.amount
     *
     * *Gets pcoModel.granted_product_multi.limit_amount.amount parameter*
     *
     * @returns {number} this.abreCuentasModel.pcoModel.granted_product_multi.limit_amount.amount*
     */
    AbreCuentasService.prototype.getAmountPcoProducType = function (productType) {
        var dataProduct = this.abreCuentasModel.pcoModelMulti[0].granted_product_multi.find(function (product) { return product.product_type === productType; });
        console.log('--getAmountPcoAprovedMulti-dataProduct', dataProduct);
        return dataProduct === undefined ? ' ' : dataProduct.product_type;
    };
    /**
     * Inicializa el parámetro simulatorModel igual a simulatorModel
     *
     * *Sets simulatorModel parameter equal to simulatorModel*
     *
     * @param {SimulatorModel} simulatorModel
     */
    AbreCuentasService.prototype.setSimulatorModel = function (simulatorModel) {
        this.abreCuentasModel.simulatorModel = simulatorModel;
    };
    /**
     * Obtiene el parámetro de simulatorModel
     *
     * *Gets simulatorModel parameter*
     *
     * @returns {SimulatorModel} this.abreCuentasModel.simulatorModel
     */
    AbreCuentasService.prototype.getSimulatorModel = function () {
        return this.abreCuentasModel.simulatorModel;
    };
    /**
     * Inicializa el parámetro loanModel igual a loanModel
     *
     * *Sets loanModel parameter equal to loanModel*
     *
     * @param {LoanModel} loanModel
     */
    AbreCuentasService.prototype.setLoanModel = function (loanModel) {
        this.abreCuentasModel.loanModel = loanModel;
    };
    /**
     * Obtiene el parámetro de loanModel
     *
     * *Gets loanModel parameter*
     *
     * @returns {LoanModel} this.abreCuentasModel.loanModel
     */
    AbreCuentasService.prototype.getLoanModel = function () {
        return this.abreCuentasModel.loanModel;
    };
    /**
     * Inicializa el parámetro pcoModeligual igual a pcoModel
     *
     * *Sets pcoModel parameter equal to pcoModel*
     *
     * @param {PcoModel} pcoModel
     */
    AbreCuentasService.prototype.setPcoModel = function (pcoModel) {
        this.abreCuentasModel.pcoModel = pcoModel;
    };
    /**
     * Inicializa el parámetro pcoModelMulti igual igual a pcoModel[]
     *
     * *Sets pcoModelMulti parameter equal to pcoModel[]*
     *
     * @param {PcoModel} pcoModel
     */
    AbreCuentasService.prototype.setPcoModelMulti = function (pcoModelMulti) {
        this.abreCuentasModel.pcoModelMulti = pcoModelMulti;
    };
    /**
     * retorna el parámetro pcoModelMulti igual igual a pcoModel[]
     * @returns  {PcoModel} pcoModel
     */
    AbreCuentasService.prototype.getPcoModelMulti = function () {
        return this.abreCuentasModel.pcoModelMulti; // return this.dataMockForPcoResponse.data[0];
    };
    /**
     * Obtiene el parámetro de pcoModel
     *
     * *Gets pcoModel parameter*
     *
     * @returns {PcoModel} this.abreCuentasModel.pcoModel
     */
    AbreCuentasService.prototype.getPcoModel = function () {
        return this.abreCuentasModel.pcoModel;
    };
    /**
     * Determina si es zona gris o no
     *
     * *Gets grayZone status*
     *
     * @returns {boolean}
     */
    AbreCuentasService.prototype.isGrayZone = function () {
        var solicitationStatus = this.abreCuentasModel.pcoModel.solicitation_status;
        if (solicitationStatus) {
            return (this.abreCuentasModel.pcoModel.solicitation_status.status_code ===
                'PCO03');
        }
        return false;
    };
    /**
     * Inicializa el parámetro cardType igual a cardType
     *
     * *Sets cardType parameter equal to cardType*
     *
     *  @param {CardTypeModel} cardType
     */
    AbreCuentasService.prototype.setCardTypeModel = function (cardType) {
        this.abreCuentasModel.cardType = cardType;
    };
    /**
     * Obtiene el parámetro de cardType
     *
     * *Gets cardType parameter*
     *
     * @returns {CardTypeModel} this.abreCuentasModel.cardType
     */
    AbreCuentasService.prototype.getCardTypeModel = function () {
        return this.abreCuentasModel.cardType;
    };
    /**
     * Inicializa el parámetro cardTypes igual a cardTypes
     *
     * *Sets cardTypes parameter equal to cardTypes*
     *
     *  @param {} cardTypes
     */
    AbreCuentasService.prototype.setCardTypesModel = function (cardTypes) {
        this.abreCuentasModel.cardTypes = cardTypes;
    };
    /**
     * Obtiene el parámetro de cardTypes
     *
     * *Gets cardTypes parameter*
     *
     * @returns {} this.abreCuentasModel.cardTypes
     */
    AbreCuentasService.prototype.getCardTypesModel = function () {
        return this.abreCuentasModel.cardTypes;
    };
    /**
     * Inicializa el parámetro productCard igual a productCard
     *
     * *Sets productCard parameter equal to productCard*
     *
     * @param {ProductCard} productCard
     */
    AbreCuentasService.prototype.setProductCard = function (productCard) {
        this.abreCuentasModel.productCard = productCard;
    };
    /**
     * Obtiene el parámetro de productCard
     *
     * *Gets productCard parameter*
     *
     * @returns {ProductCard} this.abreCuentasModel.productCard
     */
    AbreCuentasService.prototype.getProductCard = function () {
        return this.abreCuentasModel.productCard;
    };
    /**
     * Obtiene el parámetro de deviceInfoModel
     *
     * *Gets deviceInfoModel parameter*
     *
     * @returns {DeviceInfoModel} this.abreCuentasModel.deviceInfoModel
     */
    AbreCuentasService.prototype.getDeviceInfo = function () {
        return this.abreCuentasModel.deviceInfoModel;
    };
    /**
     * Inicializa el parámetro deviceInfo igual a deviceInfo
     *
     * *Sets deviceInfo parameter equal to deviceInfo*
     *
     * @param {DeviceInfoModel} deviceInfo
     */
    AbreCuentasService.prototype.setDeviceInfo = function (deviceInfo) {
        this.abreCuentasModel.deviceInfoModel = deviceInfo;
    };
    /**
     * Obtiene el parámetro de transactionInfoModel
     *
     * *Gets transactionInfoModel parameter*
     *
     * @returns {TransactionInfoModel} this.abreCuentasModel.transactionInfoModel
     */
    AbreCuentasService.prototype.getTransactionInfo = function () {
        return this.abreCuentasModel.transactionInfoModel;
    };
    /**
     * Inicializa el parámetro transactionInfo igual a transactionInfo
     *
     * *Sets transactionInfo parameter equal to transactionInfo*
     *
     * @param {TransactionInfoModel} transactionInfo
     */
    AbreCuentasService.prototype.setTransactionInfo = function (transactionInfo) {
        this.abreCuentasModel.transactionInfoModel = transactionInfo;
    };
    /**
     * Obtiene el parámetro de appInfo
     *
     * *Gets appInfo parameter*
     *
     * @returns {AppInfoModel} this.abreCuentasModel.appInfo
     */
    AbreCuentasService.prototype.getAppInfo = function () {
        return this.abreCuentasModel.appInfo;
    };
    /**
     * Inicializa el parámetro appInfo igual a appInfo
     *
     * *Sets appInfo parameter equal to appInfo*
     *
     * @param {AppInfoModel} appInfo
     */
    AbreCuentasService.prototype.setAppInfo = function (appInfo) {
        this.abreCuentasModel.appInfo = appInfo;
    };
    /**
     * Obtiene el parámetro de readCustomerService
     *
     * *Gets readCustomerService parameter*
     *
     * @returns {boolean} this.abreCuentasModel.readCustomerService
     */
    AbreCuentasService.prototype.getReadCustomerService = function () {
        return this.abreCuentasModel.readCustomerService;
    };
    /**
     * Inicializa el parámetro readCustomerService igual a readCustomerService
     *
     * *Sets readCustomerService parameter equal to readCustomerService*
     *
     * @param {boolean} readCustomerService
     */
    AbreCuentasService.prototype.setReadCustomerService = function (readCustomerService) {
        this.abreCuentasModel.readCustomerService = readCustomerService;
    };
    /**
     * Obtiene el parámetro de imageLottieError
     *
     * *Gets imageLottieError parameter*
     *
     * @returns {LottieImage} *this.abreCuentasModel.imageLottieError*
     */
    AbreCuentasService.prototype.getImageLottieError = function () {
        return this.abreCuentasModel.imageLottieError;
    };
    /**
     * Inicializa el parámetro imageLottieError igual a imageLottieError
     *
     * *Sets imageLottieError parameter equal to imageLottieError*
     *
     * @param {LottieImage} imageLottieError
     */
    AbreCuentasService.prototype.setImageLottieError = function (imageLottieError) {
        this.abreCuentasModel.imageLottieError = imageLottieError;
    };
    /**
     * Inicializa el parámetro registerBytteLicensePromise igual a promise
     *
     * *Sets registerBytteLicensePromise parameter equal to promise*
     *
     *  @param {Promise<any>} promise
     */
    AbreCuentasService.prototype.setRegisterBytteLicensePromise = function (promise) {
        this.registerBytteLicensePromise = promise;
    };
    /**
     * Obtiene el parámetro de registerBytteLicensePromise
     *
     * *Gets registerBytteLicensePromise parameter*
     *
     * @returns {Promise<any>} this.registerBytteLicensePromise
     */
    AbreCuentasService.prototype.getRegisterBytteLicensePromise = function () {
        return this.registerBytteLicensePromise;
    };
    /**
     * Verifica si la variable str es vacia
     *
     * *Verify that str variable is empty*
     *
     * @param {string} str
     * @returns {boolean} true or false
     */
    AbreCuentasService.prototype.isEmpty = function (str) {
        return !str || str.trim().length === 0;
    };
    /**
     * Obtiene el parámetro de showMessageUpdate
     *
     * *Gets showMessageUpdate parameter*
     *
     * @returns {boolean} this.abreCuentasModel.showMessageUpdate
     */
    AbreCuentasService.prototype.getShowMessageUpdate = function () {
        return this.abreCuentasModel.showMessageUpdate;
    };
    /**
     * Inicializa el parámetro showMessageUpdate igual a showMessageUpdate
     *
     * *Sets showMessageUpdate parameter equal to showMessageUpdate*
     *
     * @param {boolean} showMessageUpdate
     */
    AbreCuentasService.prototype.setShowMessageUpdate = function (showMessageUpdate) {
        this.abreCuentasModel.showMessageUpdate = showMessageUpdate;
    };
    /**
     * Obtiene el parámetro de updateClient
     *
     * *Gets updateClient parameter*
     *
     * @returns {boolean} this.abreCuentasModel.updateClient
     */
    AbreCuentasService.prototype.getUpdateClient = function () {
        return this.abreCuentasModel.updateClient;
    };
    /**
     * Inicializa el parámetro updateClient igual a updateClient
     *
     * *Sets updateClient parameter equal to updateClient*
     *
     * @param {boolean} updateClient
     */
    AbreCuentasService.prototype.setUpdateClient = function (updateClient) {
        this.abreCuentasModel.updateClient = updateClient;
    };
    /**
     * Obtiene el parámetro de devicePermissions
     *
     * *Gets devicePermissions parameter*
     *
     * @returns {string} *this.devicePermissions*
     */
    AbreCuentasService.prototype.getDevicePermissions = function () {
        return this.devicePermissions;
    };
    /**
     * Inicializa el parámetro this.devicePermissions igual a permissions
     *
     * *Sets this.devicePermissions parameter equal to permissions*
     *
     * @param {string} permissions
     */
    AbreCuentasService.prototype.setDevicePermissions = function (permissions) {
        this.devicePermissions = permissions;
    };
    /**
     * Inicializa el parámetro this.geoLocalization igual a location
     *
     * *Sets this.geoLocalization parameter equal to location*
     *
     *  @param {string} location
     */
    AbreCuentasService.prototype.setGeoLocation = function (location) {
        this.geoLocalization = location;
    };
    /**
     * Obtiene el parámetro de geoLocalization
     *
     * *Gets geoLocalization parameter*
     *
     * @returns {string} *this.geoLocalization*
     */
    AbreCuentasService.prototype.getGeoLocation = function () {
        return this.geoLocalization;
    };
    /**
     * Realiza la conversión de una cadena de texto a PascalCase
     *
     * *Coverts a string to PascalCase*
     *
     * @param {string} word
     * @returns string word in PascalCase
     */
    AbreCuentasService.prototype.converttoPascalCase = function (word) {
        if (word.split(' ').length > 1) {
            var newWord = word.split(' ');
            var finalWord_1 = '';
            newWord.forEach(function (separate_word) {
                finalWord_1 +=
                    separate_word.charAt(0).toUpperCase() +
                        separate_word.substr(1).toLowerCase() +
                        ' ';
            });
            return finalWord_1.trim();
        }
        return word.charAt(0).toUpperCase() + word.substr(1).toLowerCase();
    };
    /**
     * Realiza la conversión de una imagen a un DataUrl por medio de Canvas
     *
     * *Coverts an image to DataUrl via Canvas*
     *
     * @param {any} url
     * @param {any} outputFormat
     *
     * @returns An image in DataUrl format
     */
    AbreCuentasService.prototype.convertToDataURLviaCanvas = function (url, outputFormat) {
        return new Promise(function (resolve, _reject) {
            var img = new Image();
            img.crossOrigin = '*';
            img.onload = function () {
                var canvas = document.createElement('CANVAS');
                var ctx = canvas.getContext('2d');
                var dataURL;
                canvas.height = img.height;
                canvas.width = img.width;
                ctx.drawImage(img, 0, 0);
                dataURL = canvas.toDataURL(outputFormat);
                resolve(dataURL);
            };
            img.src = url;
        });
    };
    /**
     * Procesa una imagen en Base64
     *
     * *Proccess an image in Base64 form*
     *
     * @param {string} data_img
     * @returns An image in Base64 form
     */
    AbreCuentasService.prototype.proccessBase64 = function (data_img) {
        return data_img.split(',')[1];
    };
    /**
     * Normaliza una cadena de texto
     *
     * *Normalize a string*
     *
     * @param {string} input
     * @returns {string} Normalized text
     */
    AbreCuentasService.prototype.normalize = function (input) {
        return input
            .normalize('NFD')
            .replace(/[\u0300-\u036f]/g, '')
            .replace(/ /g, '')
            .toLowerCase()
            .trim();
    };
    /**
     * Busca una ciudad por los parámetros name, province_code o list
     *
     * *Search a city by name, province_code or list parameters*
     *
     * @param {string} name
     * @param {number} province_code
     * @param {CityModelAlt[]} list
     *
     * @returns {CityModelAlt} City
     */
    AbreCuentasService.prototype.filterCity = function (name, province_code, list) {
        var _this = this;
        return list.filter(function (element, _index, _array) {
            return (element.province_code === province_code &&
                _this.normalize(element.description.split(',')[0]) ===
                    _this.normalize(name));
        })[0];
    };
    /**
     * Obtiene el parámetro que debe ser buscado en la consulta de acuerdo a los parámetros name y url
     *
     * *Gets de parameter that must be part of the query from name and url parameters*
     *
     * @param {string} name
     * @param {string} url
     * @returns {string} Result of Query Param By Name
     */
    AbreCuentasService.prototype.getQueryParamByName = function (name, url) {
        var e_1, _a;
        var search = url.substring(1);
        var params = search.split('&');
        var result = '';
        try {
            for (var params_1 = tslib_1.__values(params), params_1_1 = params_1.next(); !params_1_1.done; params_1_1 = params_1.next()) {
                var param = params_1_1.value;
                var newParam = param.split('=');
                var paramName = newParam[0];
                var paramValue = newParam[1];
                if (paramName === name && paramValue && paramValue.trim().length > 0) {
                    result = paramValue;
                }
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (params_1_1 && !params_1_1.done && (_a = params_1.return)) _a.call(params_1);
            }
            finally { if (e_1) throw e_1.error; }
        }
        return result;
    };
    /**
     * Inicializa el parámetro receiveCard igual a elementId
     *
     * *Sets receiveCard parameter equal to elementId*
     *
     * @param {string} elementId
     */
    AbreCuentasService.prototype.setReceiveCard = function (elementId) {
        this.abreCuentasModel.receiveCard = elementId;
    };
    /**
     * Control para el evento volver de add loan
     *
     * controls for the back evento in add loan
     *
     * @param {boolean} back
     */
    AbreCuentasService.prototype.setDidBackAddLoan = function (back) {
        this.didBackAddLoan = back;
    };
    AbreCuentasService.prototype.getDidBackAddLoan = function () {
        return this.didBackAddLoan;
    };
    /**
     * Obtiene el parámetro de receiveCard
     *
     * *Gets receiveCard parameter*
     *
     * @returns {string} this.abreCuentasModel.receiveCard
     */
    AbreCuentasService.prototype.getReceiveCard = function () {
        return this.abreCuentasModel.receiveCard;
    };
    /**
     * Inicializa el parámetro updateMail igual a elementId
     *
     * *Sets updateMail parameter equal to elementId*
     *
     * @param {boolean} elementId
     */
    AbreCuentasService.prototype.setUpdatingMail = function (elementId) {
        this.abreCuentasModel.updateMail = elementId;
    };
    /**
     * Obtiene el parámetro de updateMail
     *
     * *Gets updateMail parameter*
     *
     * @returns {boolean} this.abreCuentasModel.updateMail
     */
    AbreCuentasService.prototype.getUpdatingMail = function () {
        return this.abreCuentasModel.updateMail;
    };
    /**
     * Inicializa el parámetro updatePhone igual a elementId
     *
     * *Sets updatePhone parameter equal to elementId*
     *
     * @param {boolean} elementId
     */
    AbreCuentasService.prototype.setUpdatingPhone = function (elementId) {
        this.abreCuentasModel.updatePhone = elementId;
    };
    /**
     * Obtiene el parámetro de updatePhone
     *
     * *Gets updatePhone parameter*
     *
     * @returns {boolean} this.abreCuentasModel.updatePhone
     */
    AbreCuentasService.prototype.getUpdatingPhone = function () {
        return this.abreCuentasModel.updatePhone;
    };
    /**
     * Inicializa el parámetro updatePhone igual a elementId
     *
     * *Sets updatePhone parameter equal to elementId*
     *
     * @param {boolean} elementId
     */
    AbreCuentasService.prototype.setPayDay = function (day) {
        this.abreCuentasModel.payDay = day;
    };
    /**
     * Obtiene el parámetro de productSelected
     *
     * *Gets productSelected parameter*
     *
     * @returns {IProductsModel} this.abreCuentasModel.productSelected
     */
    AbreCuentasService.prototype.getcreateProductSelected = function () {
        return this.abreCuentasModel.createProduct;
    };
    /**
     * Inicializa el parámetro productSelected igual productSelected
     *
     * *Sets productSelected  parameter equal to productSelected*
     *
     * @param {any} productSelected
     */
    AbreCuentasService.prototype.setcreateProductSelected = function (createProduct) {
        this.abreCuentasModel.createProduct = createProduct;
    };
    /**
     * Obtiene el parámetro de updatePhone
     *
     * *Gets updatePhone parameter*
     *
     * @returns {string} this.abreCuentasModel.updatePhone
     */
    AbreCuentasService.prototype.getPAyDay = function (reverseDate) {
        var returnDate = this.abreCuentasModel.payDay;
        if (returnDate != null) {
            return reverseDate
                ? returnDate.split('/').reverse().join('-')
                : returnDate;
        }
        return null;
    };
    AbreCuentasService.prototype.setAdvisorCode = function (code) {
        this.abreCuentasModel.advisorCode = code;
    };
    AbreCuentasService.prototype.getAdvisorCode = function () {
        return this.abreCuentasModel.advisorCode;
    };
    AbreCuentasService.prototype.setAdvisorCheck = function (elementId) {
        this.abreCuentasModel.advisorCheck = elementId;
    };
    AbreCuentasService.prototype.getAdvisorCheck = function () {
        return this.abreCuentasModel.advisorCheck;
    };
    /**
     * Summary Get Flow Structure.
     */
    AbreCuentasService.prototype.getFlowStructure = function () {
        return this.abreCuentasModel.flowStructure;
    };
    /**
     * Summary Set Flow Structure.
     */
    AbreCuentasService.prototype.setFlowStructure = function (flows) {
        var multiFlowStrcuture = this.getMultiproductFlowUpdate();
        var listProductsSelected = this.getProductsSelects();
        var phase = {};
        this.abreCuentasModel.flowStructure = flows;
    };
    AbreCuentasService.prototype.setStructureMultiToCurrentFlow = function (multiFlowStrcuture) {
        var _this = this;
        if (multiFlowStrcuture['start'] !== undefined &&
            multiFlowStrcuture['start'] !== null) {
            this.abreCuentasModel.flowStructure[0].flows.multiProduct.startPhase =
                multiFlowStrcuture['start'];
        }
        Object.keys(tslib_1.__assign({}, multiFlowStrcuture['phases'])).map(function (namePhase) {
            // validamos si la fase tiene algo en la llave start
            if (multiFlowStrcuture['phases'][namePhase].start !== undefined &&
                multiFlowStrcuture['phases'][namePhase].start !== '') {
                var newObjPhase = {};
                // validamos que el flujo de multi tenga fases
                if (_this.abreCuentasModel.flowStructure[0].flows.multiProduct.phases !==
                    undefined &&
                    Object.keys(_this.abreCuentasModel.flowStructure[0].flows.multiProduct.phases).length > 0) {
                    // cambiamos el valor de la llave start de la fase.
                    _this.abreCuentasModel.flowStructure[0].flows.multiProduct.phases[namePhase].start = multiFlowStrcuture['phases'][namePhase].start;
                }
                else {
                    newObjPhase[namePhase] = multiFlowStrcuture['phases'][namePhase];
                    // agragamos la fase al flujo de multi
                    _this.abreCuentasModel.flowStructure[0].flows.multiProduct.phases =
                        newObjPhase;
                }
            }
            // validamos que la fase puesta en el archivo tenga pasos/steps
            if (multiFlowStrcuture['phases'][namePhase].steps !== undefined &&
                Object.keys(multiFlowStrcuture['phases'][namePhase].steps).length > 0) {
                // recorremos los steps puesto en el archivo de multiproducto
                Object.keys(multiFlowStrcuture['phases'][namePhase].steps).map(function (nameStep) {
                    var newObj = {};
                    // validamos que el paso/step exista en multiproducto
                    if (_this.abreCuentasModel.flowStructure[0].flows.multiProduct.phases[namePhase].steps[nameStep] !== undefined) {
                        _this.abreCuentasModel.flowStructure[0].flows.multiProduct.phases[namePhase].steps[nameStep] = Object.assign(_this.abreCuentasModel.flowStructure[0].flows.multiProduct
                            .phases[namePhase].steps[nameStep], multiFlowStrcuture['phases'][namePhase].steps[nameStep]);
                    }
                    else {
                        newObj[nameStep] =
                            multiFlowStrcuture['phases'][namePhase].steps[nameStep];
                        // agregamos el paso/step completo al flujo de multiproducto
                        _this.abreCuentasModel.flowStructure[0].flows.multiProduct.phases[namePhase].steps = Object.assign(tslib_1.__assign({}, _this.abreCuentasModel.flowStructure[0].flows.multiProduct
                            .phases[namePhase].steps), newObj);
                    }
                });
            }
        });
    };
    AbreCuentasService.prototype.setMultiproductFlowUpdate = function (dataFlowUpdate) {
        this.abreCuentasModel.multiproductFlowUpdate = dataFlowUpdate;
    };
    AbreCuentasService.prototype.getMultiproductFlowUpdate = function () {
        return this.abreCuentasModel.multiproductFlowUpdate;
    };
    AbreCuentasService.prototype.getMultiflowStructurePhases = function (phases) {
        return this.abreCuentasModel.flowStructure[0].flows[phases].phases;
    };
    /**
     * Se indica si el lciente existente tiene o no algún producto activo
     *
     *
     * @param {DocumentModel} model
     */
    AbreCuentasService.prototype.setClientProduct = function (isclientProduct) {
        this.abreCuentasModel.isclientProduct = isclientProduct;
    };
    /**
     * Obtenego un booleano donde me indica si el cliente tiene o no un producto
     *
     * *Gets documentModel parameter*
     *
     */
    AbreCuentasService.prototype.getClientProduct = function () {
        return this.abreCuentasModel.isclientProduct;
    };
    /**
     * Se indica si el lciente existente tiene o no algún producto activo
     *
     *
     * @param {DocumentModel} model
     */
    AbreCuentasService.prototype.setListClientProduct = function (listclientProduct) {
        this.abreCuentasModel.listclientProduct = listclientProduct;
    };
    /**
     * Obtenego un booleano donde me indica si el cliente tiene o no un producto
     *
     * *Gets documentModel parameter*
     *
     */
    AbreCuentasService.prototype.getListClientProduct = function () {
        return this.abreCuentasModel.listclientProduct;
    };
    AbreCuentasService.prototype.setAppLoaded = function (value) {
        this.abreCuentasModel.appLoaded = value;
    };
    AbreCuentasService.prototype.getAppLoaded = function () {
        return this.abreCuentasModel.appLoaded;
    };
    AbreCuentasService.prototype.setIsPortal = function (value) {
        this.abreCuentasModel.isPortal = value;
    };
    AbreCuentasService.prototype.getIsPortal = function () {
        return this.abreCuentasModel.isPortal;
    };
    AbreCuentasService.prototype.setIsNewClient = function (status) {
        this.isNewClient = status;
    };
    AbreCuentasService.prototype.getIsNewClient = function () {
        return this.isNewClient;
    };
    AbreCuentasService.prototype.setCSID = function (id) {
        return (this.abreCuentasModel.CSID = id);
    };
    /**
     * Obtener transaction_id
     *
     * *Gets transaction_id*
     *
     * @returns {string} this.abreCuentasModel.transaction_id
     */
    AbreCuentasService.prototype.getCSID = function () {
        return this.abreCuentasModel.CSID;
    };
    AbreCuentasService.prototype.setPPID = function (id) {
        return (this.abreCuentasModel.PPID = id);
    };
    AbreCuentasService.prototype.getPPID = function () {
        return this.abreCuentasModel.PPID;
    };
    AbreCuentasService.prototype.setIp = function (ip) {
        return (this.abreCuentasModel.ipAddress = ip);
    };
    /**
     * Obtener ipAddress
     *
     * *Gets ipAddress*
     *
     * @returns {string} this.abreCuentasModel.ipAddress
     */
    AbreCuentasService.prototype.getIp = function () {
        return this.abreCuentasModel.ipAddress;
    };
    AbreCuentasService.prototype.setOtherSimulationData = function (value) {
        this.abreCuentasModel.otherSimulationData = value;
    };
    AbreCuentasService.prototype.getOtherSimulationData = function () {
        return this.abreCuentasModel.otherSimulationData;
    };
    AbreCuentasService.prototype.getOtherEvidentenData = function () {
        return this.abreCuentasModel.otherEvidenteDataModel;
    };
    AbreCuentasService.prototype.setOtherEvidentenData = function (value) {
        console.warn('evidente--', value);
        this.setDocumentInfo(value);
        this.setProspectResponse({
            client: value.client === undefined ? false : value.client,
        });
        this.setPostlogin(value.client);
        if (this.viewOptionMultiProduct) {
            var contactInfo = value;
            var dataContact = new ContactModel();
            dataContact.email = contactInfo.email;
            dataContact.mobile_number = contactInfo.mobile_number;
            this.setContactInfo(dataContact);
        }
        // this.abreCuentasModel.otherSimulationData = value;
    };
    /**
     * setear productos flujo multiproducto
     * @param data array de productos
     */
    AbreCuentasService.prototype.setProductsSelects = function (data) {
        this.productSelect = data.sort(function (a, b) {
            return a.prioritizeForClient - b.prioritizeForClient;
        });
    };
    /**
     * @returns products seleccionado
     */
    AbreCuentasService.prototype.getProductsSelects = function () {
        return this.productSelect;
    };
    /**
     * setear de viewOptionMultiProduct
     */
    AbreCuentasService.prototype.setMultiView = function (status) {
        this.viewOptionMultiProduct = status;
    };
    AbreCuentasService.prototype.setIsNormalizacion = function (status) {
        this.isNormalizacion = status;
    };
    AbreCuentasService.prototype.getIsNormalizacion = function () {
        return this.isNormalizacion;
    };
    /**
     * setear de isCardDuality
     */
    AbreCuentasService.prototype.setCarduality = function (status) {
        this.isCardDuality = status;
    };
    AbreCuentasService.prototype.getCarduality = function () {
        return this.isCardDuality;
    };
    /**
     * setear de haveLoan
     */
    AbreCuentasService.prototype.setHaveloan = function (status) {
        this.haveLoan = status;
    };
    AbreCuentasService.prototype.setSaveValueInputAmount = function (savevalue) {
        this.abreCuentasModel.savevaluemodel.savevaluemodel = savevalue;
    };
    AbreCuentasService.prototype.getSaveValueInputAmount = function () {
        return this.abreCuentasModel.savevaluemodel.savevaluemodel;
    };
    AbreCuentasService.prototype.setSaveValuePlazoMonto = function (termAmount) {
        this.inputTermAmount = termAmount;
    };
    AbreCuentasService.prototype.getSaveValuePlazoMonto = function () {
        return this.inputTermAmount;
    };
    AbreCuentasService.prototype.setcontractType = function (contractType) {
        this.contractTypemodel = contractType;
    };
    AbreCuentasService.prototype.getcontractType = function () {
        return 'type_of_contract' + this.contractTypemodel;
    };
    AbreCuentasService.prototype.setDisbursementConfiguration = function (DisbursementConfiguration) {
        this.DisbursementConfigurationModel = DisbursementConfiguration;
    };
    AbreCuentasService.prototype.getDisbursementConfiguration = function () {
        return this.DisbursementConfigurationModel;
    };
    AbreCuentasService.prototype.getAgreementDetailSelected = function () {
        return this.abreCuentasModel.agreementDetail.agreement;
    };
    AbreCuentasService.prototype.setAgreementDetailSelected = function (agreementDetail) {
        this.abreCuentasModel.agreementDetail = agreementDetail;
    };
    AbreCuentasService.prototype.getRequestLoanSelected = function () {
        return this.abreCuentasModel.selectLoan;
    };
    AbreCuentasService.prototype.setRequestLoanSelected = function (selected) {
        this.abreCuentasModel.selectLoan = selected;
    };
    /**
     * Obtener modelo de solicitud
     *
     * *Gets requestModel*
     *
     * @returns {requestModel} requestModel
     */
    AbreCuentasService.prototype.getRequestModel = function () {
        return this.requestModel;
    };
    /**
     * Setear el modelo de solicitud
     *
     * *Sets requestModel*
     *
     * @param {AbreCuentrequestModelasModel} requestModel
     */
    AbreCuentasService.prototype.setRequestModel = function (requestModel) {
        this.requestModel = requestModel;
    };
    AbreCuentasService.prototype.getOfficeStatus = function () {
        return this.checkDisbursement;
    };
    AbreCuentasService.prototype.setOfficeStatus = function (status) {
        this.checkDisbursement = status;
    };
    AbreCuentasService.prototype.setCreditSelection = function (creditSelection) {
        this.creditSelection = creditSelection;
    };
    AbreCuentasService.prototype.getCreditSelection = function () {
        return this.creditSelection;
    };
    AbreCuentasService.prototype.setOutlaySelection = function (outlaySelection) {
        this.outlaySelection = outlaySelection;
    };
    AbreCuentasService.prototype.getOutlaySelection = function () {
        return this.outlaySelection;
    };
    AbreCuentasService.prototype.getFlowLoan = function () {
        return (this.getProductsSelects().filter(function (fil) { return fil.flow === BUSINESS_CONST.PRODUCT_TYPE_LOAN; }).length > 0);
    };
    AbreCuentasService.prototype.getFlowTCR = function () {
        return (this.getProductsSelects().filter(function (fil) { return fil.flow === BUSINESS_CONST.PRODUCT_TYPE_TC; }).length > 0);
    };
    AbreCuentasService.prototype.getFlowRotativo = function () {
        return (this.getProductsSelects().filter(function (fil) { return fil.flow === BUSINESS_CONST.PRODUCT_TYPE_REVOLVING; }).length > 0);
    };
    AbreCuentasService.prototype.getFlowCP = function () {
        return (this.getProductsSelects().filter(function (fil) { return fil.flow === BUSINESS_CONST.PRODUCT_TYPE_FREE; }).length > 0);
    };
    AbreCuentasService.prototype.setFormLoan = function (formLoan) {
        this.formLoan = formLoan;
    };
    AbreCuentasService.prototype.getFormLoan = function () {
        return this.formLoan;
    };
    AbreCuentasService.prototype.setCreditIndex = function (creditIndex) {
        this.creditIndex = creditIndex;
    };
    AbreCuentasService.prototype.getCreditIndex = function () {
        return this.creditIndex;
    };
    AbreCuentasService.prototype.setEditCredit = function (editCredit) {
        this.editCredit = editCredit;
    };
    AbreCuentasService.prototype.getEditCredit = function () {
        return this.editCredit;
    };
    AbreCuentasService.prototype.setCreditInfo = function (creditInfo) {
        this.creditInfo = creditInfo;
    };
    AbreCuentasService.prototype.setDeleteCredit = function (deleteCredit) {
        this.deleteCredit = deleteCredit;
    };
    AbreCuentasService.prototype.getDeleteCredit = function () {
        return this.deleteCredit;
    };
    AbreCuentasService.prototype.getCreditInfo = function () {
        return this.creditInfo;
    };
    AbreCuentasService.prototype.setCreditList = function (creditList) {
        this.creditList = creditList;
    };
    AbreCuentasService.prototype.getCreditList = function () {
        return this.creditList;
    };
    AbreCuentasService.prototype.setDisbursementInfo = function (disbursementInfo) {
        this.disbursementInfo = disbursementInfo;
    };
    AbreCuentasService.prototype.setSavedOtherBank = function (otherBankInfo) {
        this.otherBankAccount = otherBankInfo;
    };
    AbreCuentasService.prototype.getSavedOtherBank = function () {
        return this.otherBankAccount;
    };
    AbreCuentasService.prototype.getDisbursementInfo = function () {
        return this.disbursementInfo;
    };
    AbreCuentasService.prototype.setStatusCreate = function (status) {
        this.statuscreateaccount = status;
    };
    AbreCuentasService.prototype.getStatusCreate = function () {
        return this.statuscreateaccount;
    };
    AbreCuentasService.prototype.getLoanSelected = function () {
        var products = this.getProductsSelects();
        var haveLoan = products.filter(function (product) { return product.product_type === BUSINESS_CONST.PRODUCT_TYPE_LOAN; });
        return haveLoan.length === 1 ? true : false;
    };
    AbreCuentasService.prototype.setPageZoneGray = function (flow) {
        this.flowPageZoneGray = flow;
    };
    AbreCuentasService.prototype.getPageZoneGray = function () {
        return this.flowPageZoneGray;
    };
    AbreCuentasService.prototype.setRatesLoan = function (rates) {
        this.ratesLoan = rates;
    };
    AbreCuentasService.prototype.getRatesLoan = function () {
        return this.ratesLoan;
    };
    /**
     * Obtener modelo de solicitudes de cliente
     *
     * *Gets customerRequests*
     *
     * @returns {any} customerRequests
     */
    AbreCuentasService.prototype.getCustomerRequests = function () {
        return this.customerRequests;
    };
    /**
     * Setear el modelo de solicitudes de cliente
     *
     * *Sets customerRequests*
     *
     * @param {any} customerRequests
     */
    AbreCuentasService.prototype.setCustomerRequests = function (customerRequests) {
        this.customerRequests = customerRequests;
    };
    /**
     * Obtener modelo de solicitud
     *
     * *Gets requestModel*
     *
     * @returns {requestModel} requestModel
     */
    AbreCuentasService.prototype.getDocumentsUploaded = function () {
        return this.documentsUploaded;
    };
    /**
     * Setear el modelo de solicitud
     *
     * *Sets requestModel*
     *
     * @param {AbreCuentrequestModelasModel} requestModel
     */
    AbreCuentasService.prototype.setDocumentsUploaded = function (documentsUploaded) {
        this.documentsUploaded = documentsUploaded;
    };
    AbreCuentasService.prototype.setProductsMax = function (products) {
        this.maxproducts = products;
    };
    AbreCuentasService.prototype.getProductsMax = function () {
        return this.maxproducts;
    };
    AbreCuentasService.prototype.setDocumentarySufficiencyList = function (documentarySufficiencyList) {
        this.documentarySufficiencyList = documentarySufficiencyList;
    };
    AbreCuentasService.prototype.getDocumentarySufficiencyList = function () {
        return this.documentarySufficiencyList;
    };
    AbreCuentasService.prototype.setDataMFE = function (infoClient) {
        console.log('infoClient', infoClient);
        this.setCustomerData(infoClient);
    };
    AbreCuentasService.prototype.setProductsVincu = function (product) {
        this.productsSelectVicul.push(product);
    };
    AbreCuentasService.prototype.setPriorization = function (priorization) {
        this.priorization = priorization;
    };
    AbreCuentasService.prototype.getPriorization = function () {
        return this.priorization;
    };
    AbreCuentasService.prototype.setInsurability = function (isInsurability) {
        this.isInsurability = isInsurability;
    };
    AbreCuentasService.prototype.getInsurability = function () {
        return this.isInsurability;
    };
    AbreCuentasService.prototype.setListIsPEP = function (pep) {
        this.pep = pep;
    };
    AbreCuentasService.prototype.getListIsPEP = function () {
        return this.pep;
    };
    AbreCuentasService.prototype.setAllyCode = function (code) {
        console.log('code', code);
        this.code_ally = code;
    };
    AbreCuentasService.prototype.getAllyCode = function () {
        console.log('this.code_ally', this.code_ally);
        return this.code_ally;
    };
    AbreCuentasService.prototype.setRateAlly = function (allyRate) {
        // tslint:disable-next-line:no-unused-expression
        this.rate_ally = allyRate;
    };
    AbreCuentasService.prototype.getRateAlly = function () {
        console.log('this.rate_ally', this.rate_ally);
        return this.rate_ally;
    };
    AbreCuentasService.prototype.setflagGreyZone = function (flag) {
        this.flagGreyZone = flag;
    };
    AbreCuentasService.prototype.getflagGreyZone = function () {
        return this.flagGreyZone;
    };
    AbreCuentasService.prototype.setSeller = function (data) {
        this.seller = data;
    };
    AbreCuentasService.prototype.getSeller = function () {
        return this.seller;
    };
    AbreCuentasService.prototype.setSellerMarca = function (data) {
        this.sellerboolean = data;
    };
    AbreCuentasService.prototype.getSellerMarca = function () {
        return this.sellerboolean;
    };
    AbreCuentasService.prototype.setRequestEntity = function (data) {
        this.RequestEntityOp = data;
    };
    AbreCuentasService.prototype.getRequestEntity = function () {
        return this.RequestEntityOp;
    };
    AbreCuentasService.prototype.setRatesOffer = function (rates) {
        this.rates = rates;
    };
    AbreCuentasService.prototype.getRatesOffer = function () {
        return this.rates;
    };
    AbreCuentasService.prototype.getPassScreenCity = function () {
        return this.PassScreenCity;
    };
    AbreCuentasService.prototype.setPassScreenCity = function (value) {
        this.PassScreenCity = value;
    };
    AbreCuentasService.prototype.filterCountryListxName = function (data) {
        var country_list = this.parametersService.getSetting(OpEnum.COUNTRY_LIST);
        return country_list.find(function (item) { return item.description.toLocaleLowerCase() === data.toLocaleLowerCase(); });
    };
    AbreCuentasService.prototype.getAssociateRevolving = function () {
        return this.associate_revolving;
    };
    AbreCuentasService.prototype.setAssociateRevolving = function (createProduct) {
        this.associate_revolving = createProduct;
    };
    AbreCuentasService.prototype.getAssociateCopyRevolving = function () {
        return this.associate_copy_revolving;
    };
    AbreCuentasService.prototype.setAssociateCopyRevolving = function (createProduct) {
        this.associate_copy_revolving = createProduct;
    };
    AbreCuentasService.prototype.setvalidate = function (validate) {
        this.validate = validate;
    };
    AbreCuentasService.prototype.getvalidate = function () {
        return this.validate;
    };
    AbreCuentasService.prototype.getWasDeleteLoan = function () {
        return this.wasDeleteLoan;
    };
    AbreCuentasService.prototype.setWasDeleteLoan = function (value) {
        this.wasDeleteLoan = value;
    };
    AbreCuentasService.prototype.setParametrizedHeaders = function (parametrizedHeaders) {
        this.parametrizedHeaders = parametrizedHeaders;
    };
    AbreCuentasService.prototype.setRescueData = function (rescueData) {
        this.rescueData = rescueData;
    };
    AbreCuentasService.prototype.getRescueData = function () {
        return this.rescueData;
    };
    AbreCuentasService.prototype.rescueDataIsEmpty = function () {
        return this.rescueData === undefined ? true : false;
    };
    AbreCuentasService.prototype.getPhase = function () {
        return this.phase;
    };
    AbreCuentasService.prototype.setPhase = function (value) {
        switch (value) {
            case 'identification':
                value = 'identification';
                break;
            case 'client-data-update-tc':
                value = 'captura';
                break;
            case 'configuration':
                value = 'configuration';
                break;
            case 'sign-on':
                value = 'vinculacion';
                break;
            default:
                break;
        }
        console.log('🚀 ~ file: abre-cuentas.service.ts:4020 ~ AbreCuentasService ~ setPhase ~ value:', value);
        this.phase = value;
    };
    /**
     * setear valor booleano de si el error fue 01-04
     */
    AbreCuentasService.prototype.setIsErrorPco = function (isErrorPco) {
        this.isErrorPco = isErrorPco;
    };
    /**
     * obtener valor booleano de si el error fue 01-04
     */
    AbreCuentasService.prototype.getIsErrorPco = function () {
        return this.isErrorPco;
    };
    AbreCuentasService.prototype.setDistricts = function (districtOptions) {
        this.districtOptions = districtOptions;
    };
    AbreCuentasService.prototype.getDistricts = function () {
        return this.districtOptions;
    };
    AbreCuentasService.prototype.getUserJemelii = function () {
        return this.userJemelii;
    };
    AbreCuentasService.prototype.setUserJemelii = function (userJemelii) {
        this.userJemelii = userJemelii;
    };
    return AbreCuentasService;
}());
export { AbreCuentasService };
